<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                  $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion' }">{{
                  $t("configuracion")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{
                name: 'productos',
                query: { filtro: filtro },
                params: { idBusiness: idBusiness },
              }">
                {{ $t("productos") }}
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ action }} {{ $t("producto") }}
            </li>
          </ol>
        </nav>
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <h2 class="tituloNumier">
                <i class="fa fa-building"></i> {{ nombreNegocio }}
              </h2>
            </div>
          </div>
          <vue-tabs @tab-change="handleTabChange" v-model="tabs">
            <v-tab :key="'basico'" title="Básico">
              <div class="row">
                <div style="margin-top: 10px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label><strong>{{ $t("category") }}</strong></label>

                        <el-select class="select-default" size="large" id="listCategories" v-model="producto.idCategory"
                          filterable :placeholder="$t('seleccionaCategoria')">
                          <el-option v-for="category in listCategory" class="select-primary" :value="category.id"
                            :label="category.name" :key="category.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nameProducto"><strong>{{ $t("nombreProducto") }}
                            <span style="color: red">*</span>
                          </strong></label>
                        <input type="text" class="form-control" :class="{
                          'is-valid':
                            producto.nombreProducto.length > 0 &&
                            producto.nombreProducto.length <= maxNameProducts,
                          'is-invalid':
                            producto.nombreProducto.length > maxNameProducts,
                        }" id="nameProducto" v-bind:placeholder="$t('introduzcaNombre')"
                          v-model="producto.nombreProducto" ref="name" />
                        <input type="hidden" v-model="producto.xname" />
                        <small class="form-text text-muted">
                          {{ producto.nombreProducto.length }}/50
                        </small>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="descripcionProducto"><strong>{{ $t("descripcion") }}</strong></label>
                        <input type="text" class="form-control" id="descripcionProducto"
                          v-bind:placeholder="$t('introduzcaDescripcion')" v-model="producto.descripcion" />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="barcodeProducto"><strong>{{ $t("codigoDeBarra") }}</strong></label>
                        <input type="text" class="form-control" id="barcodeProducto"
                          v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="producto.codigoBarras" />

                        <!--<div class="row" style="margin-top:5px"
                              v-if="producto.codigoBarras!==''">
                              <div class="col-md-2">
                                  <input style="width: 100%" v-model="numEtiquetas" type="number"
                                          class="form-control"></input>
                                  <small>Nº etiquetas</small>
                              </div>
                              <div class="col-md-3">
                                  <button @click="descargarCodigos"  class="btn btn-primary">Descargar
                                      códigos
                                  </button>
                              </div>
                          </div>-->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label><strong>{{ $t("colorBoton") }}</strong></label>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="amarillo" />
                          <div class="colorWrap" style="background-color: #ffec9f"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="rojo" />
                          <div class="colorWrap" style="background-color: #ffbbbb"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="verde" />
                          <div class="colorWrap" style="background-color: #c1ffc1"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="morado" />
                          <div class="colorWrap" style="background-color: #ffbfff"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="blanco" />
                          <div class="colorWrap" style="background-color: #FFFFFF"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="azul" />
                          <div class="colorWrap" style="background-color: #cad3ff"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="naranja" />
                          <div class="colorWrap" style="background-color: #ffa54a"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="gris" />
                          <div class="colorWrap" style="background-color: #bbbbbb"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="negro" />
                          <div class="colorWrap" style="background-color: #000000"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="orden"><strong>{{ $t("orden") }}</strong></label>
                        <input type="text" class="form-control" id="orden" v-bind:placeholder="'Orden'"
                          v-model="producto.orden" />
                      </div>
                    </div>

                    <div class="col-md-12" style="margin-top: 20px">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("baja") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="producto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("descuento") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="producto.descuento" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("menu") }}</strong>
                        </label>
                        <sup v-if="producto.id != 0">
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                        <sup v-else>
                          <i v-tooltip.top-center="
                            $i18n.t('paraConfigurarUnProductoComoTipoMenu')
                          " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="producto.isMenu" active-color="#13ce66" inactive-color="#bcbcbc"
                          :disabled="producto.id == 0" @change="enableMenu()">
                        </el-switch>

                        <!-- <b-form-checkbox v-model="producto.isMenu" name="check-button" switch inline size="lg" @change="enableMenu()">
                            </b-form-checkbox> -->
                      </div>
                    </div>
                    <div class="col-md-3" v-if="producto.isMenu">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("cerrado") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            'Los menús cerrados no pedirán plato en el TPV. Funcionan como un paquete cerrado de productos.'
                          " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="isClosed" active-color="#13ce66" inactive-color="#bcbcbc"
                          @change="cambiarTipoMenu()">
                        </el-switch>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 10px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label><strong>{{ $t("tipoIva") }}</strong></label>
                        <el-select v-if="!listIva" class="select-default" size="large" id="listIVA"
                          v-model="producto.tipoIva" :placeholder="$t('seleccionaIVA')">
                          <el-option v-for="iva in listaTipoIva" class="select-primary" :value="iva" :label="iva"
                            :key="iva + '- tipoIva'">
                          </el-option>
                        </el-select>

                        <el-select v-else class="select-default" size="large" id="listIVA" v-model="producto.tipoIva"
                          :placeholder="$t('seleccionaIVA')">
                          <el-option v-for="i in listIva" class="select-primary" :value="i" :label="i" :key="i + '-i'">
                          </el-option>
                        </el-select>
                        <br><br>
                        <!-- <div class="updateAlert">
                          <strong style="padding:2%"> El cálculo de precios de coste se ha trasladado a la nueva pestaña
                            "Precios de coste"</strong>
                        </div> -->
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice1"><strong>{{ $t("tarifa1") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" name="selPrice1" id="selPrice1"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice1" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" class="form-control" id="namePrice1" v-bind:placeholder="$t('tarifa1')"
                              v-model="producto.namePrice1" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price1"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- btn tarifa2-->

                    <!-- fin btn tarifa2-->
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice2"><strong>{{ $t("tarifa2") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" name="selPrice2" id="selPrice2"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice2" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" class="form-control" id="namePrice2" v-bind:placeholder="$t('tarifa2')"
                              v-model="producto.namePrice2" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price2"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- btn tarifa3-->

                    <!--fin btn tarifa3-->
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice3"><strong>{{ $t("tarifa3") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" name="selPrice3" id="selPrice3"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice3" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" class="form-control" id="namePrice3" v-bind:placeholder="$t('tarifa3')"
                              v-model="producto.namePrice3" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price3"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- btn tarifa4-->

                    <!-- fin btn tarifa4-->
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice4"><strong>{{ $t("tarifa4") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" name="selPrice4" id="selPrice4"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice4" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" class="form-control" id="namePrice4" v-bind:placeholder="$t('tarifa4')"
                              v-model="producto.namePrice4" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price4"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab :key="'avanzado'" title="Avanzado">
              <div class="row">
                <div style="margin-top: 10px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="opcion1"><strong>{{
                            $t("opcionesAlSeleccionarElArticulo")
                        }}</strong></label>
                        <input type="text" class="form-control" id="opcion1" v-bind:placeholder="$t('opcion1')"
                          v-model="producto.opcion1" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion2"
                          v-bind:placeholder="$t('opcion2')" v-model="producto.opcion2" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion3"
                          v-bind:placeholder="$t('opcion3')" v-model="producto.opcion3" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion4"
                          v-bind:placeholder="$t('opcion4')" v-model="producto.opcion4" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion5"
                          v-bind:placeholder="$t('opcion5')" v-model="producto.opcion5" />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("seleccionIngredientes") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="producto.seleccionarIngredientes" active-color="#13ce66"
                          inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="numberSubs"><strong>{{
                            $t("numeroDeOpcionales")
                        }}</strong></label>
                        <input type="number" class="form-control" id="numberSubs" max="5"
                          v-bind:placeholder="$t('numOpcionales')" v-model="producto.numOpcionales" />
                      </div>
                    </div>
                  </div>
                </div>

                <div style="margin-top: 30px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.precio" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>

                        <label>
                          <strong>{{ $t("pedirPrecio") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.peso" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("pedirPeso") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.importe" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("pedirImporte") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.promocionable" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("promocionable") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="''" class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.mostrarPC" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("mostrarPC") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alActivarEstaOpcionElProductoNoApareceraEnNumierTPV'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.mostrarPDA" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("mostrarPDA") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alActivarEstaOpcionElProductoNoApareceraEnLaPda'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.noImprimir" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("noImprimir") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="
                            $i18n.t(
                              'alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada'
                            )
                          " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="numberPlato"><strong>{{ $t("numeroPlato") }}</strong></label>
                        <vue-numeric type="text" id="numberPlato" class="form-control" :min="0" :max="99" placeholder="0"
                          currency-symbol-position="suffix" v-model="producto.numPlato">
                        </vue-numeric>
                        <!--<input type="number" class="form-control" id="numberPlato" max="5"
                          v-bind:placeholder="$t('numeroPlato')" v-model="producto.numPlato" />-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            
            <v-tab :key="'modos'" title="Modos" v-if="listModos.length >= 1">
              <div class="col-md-12 container">
                <div class="row">
                  <div class="table-responsive" style="overflow: auto" v-for="(modo, index) in listModos">
                    
                      <div class="form-group">

                        <div class="col-md-2" style="display: inline-block !important;">
                          <strong><del v-if="modo.deshabilitado == 1">{{ modo.nombreModo }}</del><spam v-else>{{ modo.nombreModo }}</spam></strong>
                        </div>

                        <div class="col-md-1" style="display: inline-block !important;">
                          <label for="tarifa1"><strong>{{ $t("tarifa1") }}</strong></label>
                          <br v-if="modo.deshabilitado == 1">
                          <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control" :read-only="modo.deshabilitado == 1"
                            currency-symbol-position="suffix" :precision="2" v-model="modo.tarifa1"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>

                        <div class="col-md-1" style="display: inline-block !important;">
                          <label for="tarifa2"><strong>{{ $t("tarifa2") }}</strong></label>
                          <br v-if="modo.deshabilitado == 1">
                          <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control" :read-only="modo.deshabilitado == 1"
                            currency-symbol-position="suffix" :precision="2" v-model="modo.tarifa2"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>

                        <div class="col-md-1" style="display: inline-block !important;">
                          <label for="tarifa3"><strong>{{ $t("tarifa3") }}</strong></label>
                          <br v-if="modo.deshabilitado == 1">
                          <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control" :read-only="modo.deshabilitado == 1"
                            currency-symbol-position="suffix" :precision="2" v-model="modo.tarifa3"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>

                        <div class="col-md-1" style="display: inline-block !important;">
                          <label for="tarifa4"><strong>{{ $t("tarifa4") }}</strong></label>
                          <br v-if="modo.deshabilitado == 1">
                          <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control" :read-only="modo.deshabilitado == 1"
                            currency-symbol-position="suffix" :precision="2" v-model="modo.tarifa4"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>

                        <div class="col-md-2" style="display: inline-block !important;">
                          <label><strong>{{ $t("tipoIva") }}</strong></label>
                          <el-select class="select-default" size="large" id="listIVA" :disabled="modo.deshabilitado == 1"
                            v-model="modo.impuesto" :placeholder="$t('seleccionaIVA')">
                            <el-option v-for="iva in listaTipoIva" class="select-primary" :value="iva" :label="iva"
                              :key="iva + '- tipoIva'">
                            </el-option>
                          </el-select>
                        </div>

                        <div class="col-md-1" style="display: inline-block !important;">
                          <div class="form-group">
                            <label>
                              <strong>{{ $t("noMostrar") }}</strong>
                            </label>
                            <el-switch v-model="modo.baja" active-color="#13ce66" inactive-color="#bcbcbc" :disabled="modo.deshabilitado == 1">
                            </el-switch>
                          </div>
                        </div>

                        <div class="col-md-1" style="display: inline-block !important;">
                          <div class="form-group">
                            <label>
                              <strong>{{ $t("deshabilitar") }}</strong>
                            </label>
                            <el-switch v-model="modo.deshabilitado" active-color="#13ce66" inactive-color="#bcbcbc">
                            </el-switch>
                          </div>
                        </div>

                      </div>

                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab :key="'preciosCoste'" title="Precios de coste">
              <!-- CONTINUAR AQUI -->
              
              <div class="extraAverageInfo">
                <p>Para calcular el Precio de Coste, se suman el coste de las bases, la media de los opcionales y, finalmente, se consideran los extras vendidos de este producto en el último mes para añadir su media al total.</p>
                <p>Por defecto, el cálculo del extra no se incluye en el total. Si desea incluirlo, marque la casilla a continuación.</p>
              </div>

              <!-- btn tarifa 1-->
              <div class="col-md-12">

                <div class="applyExtraAverage">
                  <label>
                    <input type="checkbox" v-model="isExtraAverageChecked" /> 
                    <strong>Incluir la media de extras en el cálculo</strong>
                  </label>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 1</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCoste"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 1</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCosteSinIVA"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--fin btn tarifa 1-->
              <!-- btn tarifa2-->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 2</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCoste2"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 2</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCosteSinIVA2"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- fin btn tarifa2-->

              <!-- btn tarifa3-->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 3</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCoste3"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 3</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCosteSinIVA3"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--fin btn tarifa3-->

              <!-- btn tarifa4-->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 4</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCoste4"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 4</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA" class="form-control me-2"
                          currency-symbol-position="suffix" :precision="2" v-model="producto.precioCosteSinIVA4"
                          @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked)" v-tooltip.top-center="
                          $t('calcularCostoAPartirDeMateriasPrimas')
                        " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- fin btn tarifa4-->

            </v-tab>
            <v-tab :key="'impresion'" title="Impresión">
              <div class="row">
                <div class="col-md-12">
                  <p class="wrapperTitleImpresion">
                    {{ $t("impresionDeComandas") }}
                  </p>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                            $t("impresoraComandasTPV")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="impresoraComandasTPV"
                          v-model="producto.printerName" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                            $t("impresoraComandasPDA")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="impresoraComandasPDA"
                          v-model="producto.printerPDAName" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasPDA')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <p class="wrapperTitleImpresion">
                    {{ $t("copiaDeImpresionDeComandas") }}
                  </p>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                            $t("copiaImpresoraComandasTPV")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresoraComandasTPV"
                          v-model="producto.printerName2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                            $t("copiaImpresoraComandasPDA")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresoraComandasPDA"
                          v-model="producto.printerPDAName2" filterable placeholder="seleccionaImpresoraDeComandasPDA">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="wrapperTitleImpresion">
                        {{ $t("monitorDeCocina") }}
                      </p>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionKDSTPV") }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionKDSTPV"
                          v-model="producto.impresionKDSTPV" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionKDSTPV") }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionKDSTPV"
                          v-model="producto.copiaImpresionKDSTPV" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionKDSPDA") }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionKDSPDA"
                          v-model="producto.impresionKDSPDA" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionKDSPDA") }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionKDSPDA"
                          v-model="producto.copiaImpresionKDSPDA" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <br>
                </div>
                <div class="col-md-12">

                  <div class="row">
                    <div class="col-md-12">
                      <p class="wrapperTitleImpresion">
                        {{ $t("impresionPorPlana") }}
                      </p>
                    </div>


                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano1"
                          v-model="producto.impresionPlano1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano1"
                          v-model="producto.copiaImpresionPlano1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano2"
                          v-model="producto.impresionPlano2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano2"
                          v-model="producto.copiaImpresionPlano2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano3"
                          v-model="producto.impresionPlano3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano3"
                          v-model="producto.copiaImpresionPlano3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano4"
                          v-model="producto.impresionPlano4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano4"
                          v-model="producto.copiaImpresionPlano4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano5"
                          v-model="producto.impresionPlano5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano5"
                          v-model="producto.copiaImpresionPlano5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano6"
                          v-model="producto.impresionPlano6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano6"
                          v-model="producto.copiaImpresionPlano6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano7"
                          v-model="producto.impresionPlano7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano7"
                          v-model="producto.copiaImpresionPlano7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano8"
                          v-model="producto.impresionPlano8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano8"
                          v-model="producto.copiaImpresionPlano8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="col-md-12">

                  <div class="row">
                    <div class="col-md-12">
                      <p class="wrapperTitleImpresion">
                        {{ $t("impresionPorKDS") }}
                      </p>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS1"
                          v-model="producto.impresionPlanoKDS1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS1"
                          v-model="producto.copiaImpresionPlanoKDS1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS2"
                          v-model="producto.impresionPlanoKDS2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS2"
                          v-model="producto.copiaImpresionPlanoKDS2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS3"
                          v-model="producto.impresionPlanoKDS3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS3"
                          v-model="producto.copiaImpresionPlanoKDS3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS4"
                          v-model="producto.impresionPlanoKDS4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS4"
                          v-model="producto.copiaImpresionPlanoKDS4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS5"
                          v-model="producto.impresionPlanoKDS5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS5"
                          v-model="producto.copiaImpresionPlanoKDS5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS6"
                          v-model="producto.impresionPlanoKDS6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS6"
                          v-model="producto.copiaImpresionPlanoKDS6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS7"
                          v-model="producto.impresionPlanoKDS7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS7"
                          v-model="producto.copiaImpresionPlanoKDS7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS8"
                          v-model="producto.impresionPlanoKDS8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS8"
                          v-model="producto.copiaImpresionPlanoKDS8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab v-if="idProducto" :key="'materiasprimas'" title="Materias primas">
              <div class="row">
                <div class="col-md-12" style="margin-top: 10px">
                  <button class="btn btn-primary" @click="openModalAgregarSubproducto()" :disabled="inProgress">
                    <i class="fas fa-search"></i> {{ $t("buscarMateriaPrima") }}
                  </button>
                  <button class="btn btn-success" @click="openModalNuevoSubproducto()" :disabled="inProgress">
                    <i class="fas fa-plus"></i> {{ $t("nuevaMateriaPrima") }}
                  </button>
                  <button class="btn btn-warning" @click="editSubproduct()" :disabled="inProgress">
                    <i class="fas fa-save"></i> {{ $t("guardarMateriaPrima") }}
                  </button>

                  <button class="btn btn-dribbble" @click="openModalCopiarSub()" :disabled="inProgress">
                    <i class="fas fa-exchange-alt"></i>
                    {{ $t("copiaMateriaPrima") }}
                  </button>

                  <span style="float: right">
                    <button @click="ordenarSubproductos" v-if="ordenarSubproduct" class="btn-success btn-sm">
                      <i class="far fa-save"></i> {{ $t("guardarOrden") }}
                    </button>
                    <input type="checkbox" name="sortProducts" v-model="ordenarSubproduct" id="sortProducts" />
                    <label for="sortProducts" style="cursor:pointer;">
                      <strong>{{ $t("ordenarSubproductos") }}</strong></label>
                  </span>
                </div>

                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ $t("nombre") }}</th>
                          <th width="10%">{{ $t("partesT1") }}</th>
                          <th width="10%">{{ $t("partesT2") }}</th>
                          <th width="10%">{{ $t("partesT3") }}</th>
                          <th width="10%">{{ $t("partesT4") }}</th>
                          <th width="18%">{{ $t("tipo") }}</th>
                          <th colspan="2" width="15%">{{ $t("variacion") }}</th>
                          <th width="5%">{{ $t("coste") }}</th>
                          <th width="5%">{{ $t("costeSinIVA") }}</th>
                          <th width="7%">
                            {{ $t("costeDto") }}. {{ $t("sinIVA") }}
                          </th>
                          <th width="7%">{{ $t("eliminar") }}</th>
                        </tr>
                      </thead>

                      <draggable v-model="listSubproductosByProducts" tag="tbody" :disabled="!ordenarSubproduct"
                        @start="drag = true" @end="drag = false">
                        <tr v-for="p in listSubproductosByProducts">
                          <td>
                            {{ p.name }}
                            <template v-if="p.baja">{{
                                $t("bajaConBrackets")
                            }}</template>
                          </td>
                          <td>
                            <input type="number" v-model="p.partes" class="form-control" @change="p.editado = 1"
                              min="1" />
                          </td>
                          <td>
                            <input type="number" v-model="p.partes2" class="form-control" @change="p.editado = 1"
                              min="1" :disabled="!producto.selPrice2" />
                          </td>
                          <td>
                            <input type="number" v-model="p.partes3" class="form-control" @change="p.editado = 1"
                              min="1" :disabled="!producto.selPrice3" />
                          </td>
                          <td>
                            <input type="number" v-model="p.partes4" class="form-control" @change="p.editado = 1"
                              min="1" :disabled="!producto.selPrice4" />
                          </td>
                          <td>
                            <el-select class="select-default" size="large" v-model="p.tipo"
                              @visible-change="changeTipo(1, p)" @change="(p.editado = 1), changeTipo(2, p)"
                              :placeholder="$t('seleccionaTipo')">
                              <el-option v-for="t in listaTipo" class="select-primary" :value="t.value" :label="t.label"
                                :key="t.value + '-' + t.label">
                              </el-option>
                            </el-select>
                          </td>
                          <td align="center">
                            <el-button type="success " size="mini" @click="(p.sumaresta = 'R'), (p.editado = 1)"
                              v-if="p.sumaresta === 'S'" circle>
                              <i class="fas fa-plus"></i>
                            </el-button>
                            <el-button type="danger" v-else @click="(p.sumaresta = 'S'), (p.editado = 1)" size="mini"
                              circle>
                              <i class="fas fa-minus"></i>
                            </el-button>
                          </td>
                          <td align="right">
                            <vue-numeric currency="€" inputmode="decimal" type="text" id="variacion"
                              class="form-control" currency-symbol-position="suffix" :precision="2"
                              @change="p.editado = 1" @keydown.native="$methods.evitarComasDecimales"
                              v-model="p.variacionPrecio"></vue-numeric>
                          </td>
                          <td align="right">
                            {{ getPrecioCompra(p, false) | currency }}
                          </td>
                          <td align="right">
                            {{ getPrecioCompraSinIVA(p, false) | currency }}
                          </td>
                          <td align="right">
                            {{ getPrecioCompraSinIVA(p, true) | currency }}
                            <span style="margin-left: 3px;">
                              <i v-tooltip.top-center="p.dtoCompra + '%'" style="white" class="fa fa-info-circle">
                              </i>
                            </span>
                          </td>
                          <td align="center">
                            <el-button @click="eliminarSubproducto(p)" circle>
                              <i class="fas fa-trash-alt"></i>
                            </el-button>
                          </td>
                        </tr>
                      </draggable>

                      <tr class="table-success">
                        <td>
                          <strong>{{ $t("total") }}:</strong>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td align="right">
                          {{ getTotalPrecioCompra(false) | currency }}
                        </td>
                        <td align="right">
                          {{ getTotalPrecioCompraSinIVA(false) | currency }}
                        </td>
                        <td align="right">
                          {{ getTotalPrecioCompraSinIVA(true) | currency }}
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab :key="'crearmateriasprimas'" v-if="!idProducto && !isRetail" :title="$t('crearMateriaPrima')" id="3">
              <div class="row">
                <!--CATEGORIAS-->
                <div class="col-md-4">
                  <div class="form-group">
                    <label><strong>{{ $t("etiqueta") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idTag" filterable
                      :placeholder="$t('seleccionaEtiqueta')">
                      <el-option v-for="category in listEtiquetas" class="select-primary" :value="category.id"
                        :label="category.name" :key="category.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!--PROVEEDORES-->
                <div class="col-md-4">
                  <div class="form-group">
                    <label><strong>{{ $t("proveedor") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idSupplier" filterable
                      :placeholder="$t('seleccionaProveedor')">
                      <el-option v-for="proveedor in listProveedores" class="select-primary" :value="proveedor.id"
                        :label="proveedor.name" :key="proveedor.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!--CASAS-->
                <div class="col-md-4">
                  <div class="form-group">
                    <label><strong>{{ $t("casa") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idCasa" filterable
                      :placeholder="$t('seleccionaCasa')">
                      <el-option v-for="casa in listCasas" class="select-primary" :value="casa.id" :label="casa.name"
                        :key="casa.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-8">
                  <div class="form-group">
                    <label for="nameCasa"><strong>{{ $t("nombreSubproducto") }} <span>*</span></strong></label>
                    <input type="text" class="form-control" :class="{
                      'is-valid':
                        subproducto.name.length > 0 &&
                        subproducto.name.length <= maxNameSubproducto,
                      'is-invalid':
                        subproducto.name.length > maxNameSubproducto,
                    }" id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')" v-model="subproducto.name"
                      ref="name" />
                    <input type="hidden" v-model="subproducto.xname" />
                    <small class="form-text text-muted">{{ subproducto.name.length }}/50</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="codigodebarrasubproducto">
                      <strong>{{ $t("codigoBarra") }}</strong>
                    </label>
                    <input type="text" class="form-control" id="codigodebarrasubproducto"
                      v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="subproducto.codigoBarras" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="direccionsubproducto"><strong>{{ $t("descripcion") }}</strong></label>
                            <input type="text" class="form-control" id="direccionsubproducto"
                              v-bind:placeholder="$t('introduzcaDescripcion')" v-model="subproducto.descripcion" />
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label><strong>{{ $t("tipo") }}</strong></label>

                            <el-select class="select-default" size="large" v-model="subproducto.tipo" filterable
                              :placeholder="$t('seleccionaTipo')">
                              <el-option v-for="tipo in listaTipoUn" class="select-primary" :value="tipo" :label="tipo"
                                :key="tipo">
                              </el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="escandalloSubproducto"><strong>{{ $t("escandallo") }}</strong></label>
                            <el-input-number id="escandalloSubproducto" v-model="subproducto.escandallo"
                              style="text-align: left !important;" :min="0" :precision="0" :controls="false"
                              :placeholder="$t('introduzcaEscandallo')" class="align-content-left">
                            </el-input-number>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-12">
                              <label><strong>{{ $t("colorBoton") }}</strong></label>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="amarillo" />
                                  <div class="colorWrap" style="background-color: #ffec9f"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="rojo" />
                                  <div class="colorWrap" style="background-color: #ffbbbb"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="verde" />
                                  <div class="colorWrap" style="background-color: #c1ffc1"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="morado" />
                                  <div class="colorWrap" style="background-color: #ffbfff"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="blanco" />
                                  <div class="colorWrap" style="background-color: #FFFFFF"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="azul" />
                                  <div class="colorWrap" style="background-color: #cad3ff"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="naranja" />
                                  <div class="colorWrap" style="background-color: #ffa54a"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="gris" />
                                  <div class="colorWrap" style="background-color: #bbbbbb"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="negro" />
                                  <div class="colorWrap" style="background-color: #000000"></div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="precioCompraSubproductoSinIva"><strong>{{
                                $t("precioCompraSinIva")
                            }}</strong></label>
                            <!--<input class="form-control" v-model="subproducto.precioCompraSinIva"-->
                            <!--type="number"-->
                            <!--id="precioCompraSubproductoSinIva"-->
                            <!--@change="calculatePrice(subproducto,false)"/>-->

                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="4"
                              @blur="calculatePrice(subproducto, false)" v-model="subproducto.precioCompraSinIva"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label><strong>{{ $t("tipoIva") }}</strong></label>

                            <el-select v-if="!listIva" class="select-default" size="large" v-model="subproducto.tipoIva"
                              filterable @change="calculatePrice(subproducto, false)"
                              :placeholder="$t('seleccionaIVA')">
                              <el-option v-for="iva in listaTipoIva" class="select-primary" :value="iva" :label="iva"
                                :key="iva">
                              </el-option>
                            </el-select>

                            <el-select v-else class="select-default" size="large" v-model="subproducto.tipoIva"
                              filterable @change="calculatePrice(subproducto, false)"
                              :placeholder="$t('seleccionaIVA')">
                              <el-option v-for="iva in listIva" class="select-primary" :value="iva" :label="iva"
                                :key="iva">
                              </el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="cuotaIVA"><strong>{{ $t("cuotaIVA") }}</strong></label>
                            <input class="form-control" :value="
                              (
                                subproducto.precioCompra -
                                subproducto.precioCompraSinIva
                              ).toFixed(2)
                            " type="number" disabled id="cuotaIVA" />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="precioCompraSubproducto"><strong>{{
                                $t("precioCompraConIva")
                            }}</strong></label>
                            <!--<input class="form-control" v-model="subproducto.precioCompra"-->
                            <!--type="number"-->
                            <!--id="precioCompraSubproducto"-->
                            <!--@keyup="calculatePrice(subproducto,true)"/>-->
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, true)"
                              @keydown.native="$methods.evitarComasDecimales" v-model="subproducto.precioCompra">
                            </vue-numeric>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="descuentoCompraSubproducto"><strong>{{
                                $t("descuentoCompra")
                            }}</strong></label><span style="font-size: x-small">
                              {{ $t("porcentaje") }}</span>
                            <input type="number" min="0" class="form-control" id="descuentoCompraSubproducto"
                              placeholder="0%" v-model="subproducto.descuentoCompra" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class="col-md-2" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("guardarEnAlmacen") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.guardarAlmacen" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="stockMinimoSubproducto"><strong>{{ $t("unidadesStockMinimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockMinimoSubproducto"
                      v-bind:placeholder="$t('introduzcaStockMinimo')" v-model="subproducto.stockMinimo" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="stockMinimoSubproducto"><strong>{{ $t("partesStockMinimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockMinimoPartesSubproducto"
                      v-bind:placeholder="'Inserta partes del stock mínimo'" v-model="subproducto.stockMinimoPartes" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="stockOptimoSubproducto"><strong>{{ $t("stockOptimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockOptimoSubproducto"
                      v-bind:placeholder="$t('introduzcaStockOptimo')" v-model="subproducto.stockOptimo" />
                  </div>
                </div>

                <div class="col-md-2" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("baja") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>

                <div v-if="listCuentasGastosSage.length > 1" class="col-md-12">
                  <hr />
                  <label><strong>{{ tieneDimoni ? $t('enlaceContable') : $t('sage200') }}</strong></label>
                  <br />
                  <label>{{ $t("aContinuacionSeListaranLasCuentasDeTipo") }}
                    <strong>{{ $t("gastoMinuscula") }}</strong>
                    {{ $t("paraQue") }}
                    <strong>{{ $t("asocieMinuscula") }}</strong>
                    {{ $t("unaParaSuPosterior") }}
                    <strong>{{ tieneDimoni ? $t('relacionEnContabilidad') : $t('relacionEnSage') }}</strong></label>
                  <br />
                  <el-select class="select-default select-account" v-model="subproducto.idCuenta"
                    :placeholder="$t('seleccioneUnaCuenta')">
                    <el-option v-for="cuenta in listCuentasGastosSage" class="select-primary" :value="cuenta.id" :label="
                      cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                    " :key="cuenta.id">
                    </el-option>
                  </el-select>
                  <template v-if="tieneDimoni">
                    <label for="porcentajeContable">
                      <strong>{{ $t("porcentajeContable") }}</strong>
                    </label>
                    <input type="number" min="0" max="100" class="form-control col-md-1" id="porcentajeContable"
                      v-bind:placeholder="$t('introduzcaElPorcentajeDeLaPrimeraCuentaContable')"
                      v-model="producto.porcentajeContable" />

                    <br />
                    <br />
                    <el-select class="select-default select-account" v-model="producto.idCuenta2" filterable
                      :placeholder="$t('seleccioneUnaCuenta')">
                      <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account"
                        :value="cuenta.id" :label="
                          cuenta.codigoCuenta +
                          cuenta.codigoSubCuenta +
                          ' - ' +
                          cuenta.nombreCuenta
                        " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                      </el-option>
                    </el-select>

                    <input type="number" min="0" max="100" class="form-control col-md-1"
                      style="display: inline !important;" id="porcentajeContable"
                      v-model="producto.porcentajeContable2" />

                    <br />
                    <br />
                    <el-select class="select-default select-account" v-model="producto.idCuenta3" filterable
                      :placeholder="$t('seleccioneUnaCuenta')">
                      <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account"
                        :value="cuenta.id" :label="
                          cuenta.codigoCuenta +
                          cuenta.codigoSubCuenta +
                          ' - ' +
                          cuenta.nombreCuenta
                        " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                      </el-option>
                    </el-select>

                    <input type="number" min="0" max="100" class="form-control col-md-1"
                      style="display: inline !important;" id="porcentajeContable"
                      v-model="producto.porcentajeContable3" />
                  </template>
                  <br />
                </div>
              </div>
            </v-tab>

            <!-- MENUS -->

            <v-tab :key="'platosdelmenu'" v-if="producto.isMenu && !isClosed" :title="$t('platosDelMenu')" id="5">
              <label style="margin-left: 15px" for="opcion1">
                {{ $t("platosTip1") }} <br />
                {{ $t("platosTip2") }}
              </label>
              <div class="col-md-3">
                <br />
                <div class="row">
                  <div class="col-md-10" :class="primerPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("primerPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion1" @click="editandoPrimero = true"
                        @blur="categoriesMenuShow(platos[0])" v-model="platos[0].nombrePlato"
                        v-bind:placeholder="'ENTRANTES...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="segundoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("segundoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoSegundo = true"
                        @blur="categoriesMenuShow(platos[1])" v-model="platos[1].nombrePlato"
                        v-bind:placeholder="'PRIMEROS...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="tercerPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("tercerPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoTercero = true"
                        @blur="categoriesMenuShow(platos[2])" v-model="platos[2].nombrePlato"
                        v-bind:placeholder="'SEGUNDOS...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="cuartoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("cuartoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoCuarto = true"
                        @blur="categoriesMenuShow(platos[3])" v-model="platos[3].nombrePlato"
                        v-bind:placeholder="'POSTRES...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="quintoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("quintoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoQuinto = true"
                        @blur="categoriesMenuShow(platos[4])" v-model="platos[4].nombrePlato"
                        v-bind:placeholder="'...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="sextoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("sextoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoSexto = true"
                        @blur="categoriesMenuShow(platos[5])" v-model="platos[5].nombrePlato"
                        v-bind:placeholder="'...'" />
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab :key="'productosdelmenu'" v-if="producto.isMenu" :title="$t('productosDelMenu')" id="6">
              <div v-if="!isClosed">
                <label style="margin-left: 15px" for="productos">
                  {{ $t("productosPlatosTip") }}
                </label>
                <br />
              </div>
              <div class="col-md-12">
                <div class="row mt-3" v-if="!isClosed">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label><strong>{{ $t("seleccionaUnPlato") }}:</strong></label>
                      <el-select class="select-default" v-model="platoSeleccionado" :placeholder="'Nombre del plato'">
                        <el-option v-for="p in listaPlatos" :key="p.idPlato" :label="p.nombrePlato" :value="p.idPlato">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label><strong>{{ $t("producto") }}:</strong></label>
                      <el-select class="select-default" v-model="productoSeleccionado" filterable remote reserve-keyword
                        :remote-method="searchProductosByPlato" :placeholder="$t('producto')">
                        <el-option v-for="p in listProductosTodos" :key="p.id" :label="p.nameProducto" :value="p.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-md-1 col-12" v-if="productoSeleccionado != null">
                    <br />
                    <button @click="anadirProductoAPlato(productoSeleccionado.id)"
                      class="btn btn-success mt-1 mb-3 w-100">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row mt-3" v-else>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label><strong>{{ $t("producto") }}:</strong></label>
                      <el-select class="select-default" v-model="productoSeleccionado" filterable remote reserve-keyword
                        :remote-method="searchProductoMenuCerrado" :placeholder="$t('producto')">
                        <el-option v-for="p in listProductosTodos" :key="p.id" :label="p.name" :value="p.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-md-1 col-12" v-if="productoSeleccionado != null">
                    <br />
                    <button @click="anadirProductoAMenu(productoSeleccionado.id)"
                      class="btn btn-success mt-1 mb-3 w-100">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row mt-2">
                  <table class="table table-sm mb-4 table-bordered table-striped" v-if="listProductosPlato.length > 0">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ $t("nombre") }}</th>
                        <th v-if="isClosed">{{ $t('orden') }}</th>
                        <th>{{ $t("acciones") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="prod in listProductosPlato" :key="prod.id">
                        <td width="40%">{{ prod.nameProducto }}</td>
                        <td width="10%" style="text-align: center" v-if="isClosed">
                          <el-input-number v-model="prod.n_plato" style="text-align: left !important;" :min="1"
                            :precision="0" :controls="false" :placeholder="'1'"
                            @change.native="cambiarOrdenProductoMenuCerrado(prod)" class="align-content-left">
                          </el-input-number>
                        </td>
                        <td width="5%" style="text-align: center;">
                          <span style="color: red; /*margin-left: 25px;*/" v-if="!isClosed"
                            @click="eliminarProductoDePlato(prod.id)">
                            <i class="fa fa-trash"></i>
                          </span>
                          <span v-else style="color: red; /*margin-left: 25px;*/"
                            @click="eliminarProductoMenuCerrado(prod.id_menudet)">
                            <i class="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
              </div>
            </v-tab>

            <v-tab v-if="listCuentasSage.length > 1" :key="'cuentassage'"
              :title="tieneDimoni ? $t('enlaceContable') : $t('sage200')">
              <label>{{ $t("aContinuacionSeListaranLasCuentasDeTipo") }}
                <strong>{{ $t("ventaMinuscula") }}</strong> {{ $t("paraQue") }}
                <strong>{{ $t("asocieMinuscula") }}</strong>
                {{ $t("unaParaSuPosterior") }}
                <strong>{{ tieneDimoni ? $t('relacionEnContabilidad') : $t('relacionEnSage') }}</strong></label>
              <br />
              <br />
              <el-select class="select-default select-account" v-model="producto.idCuenta" filterable
                :placeholder="$t('seleccioneUnaCuenta')">
                <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account" :value="cuenta.id"
                  :label="
                    cuenta.codigoCuenta +
                    cuenta.codigoSubCuenta +
                    ' - ' +
                    cuenta.nombreCuenta
                  " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                </el-option>
              </el-select>
              <template v-if="tieneDimoni">
                <!--<label for="porcentajeContable">
                  <strong>{{ $t("porcentajeContable") }}</strong>
                </label>-->
                <input type="number" min="0" max="100" class="form-control col-md-1" style="display: inline !important;"
                  id="porcentajeContable" v-model="producto.porcentajeContable" />

                <br />
                <br />
                <el-select class="select-default select-account" v-model="producto.idCuenta2" filterable
                  :placeholder="$t('seleccioneUnaCuenta')">
                  <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account" :value="cuenta.id"
                    :label="
                      cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                    " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                  </el-option>
                </el-select>

                <input type="number" min="0" max="100" class="form-control col-md-1" style="display: inline !important;"
                  id="porcentajeContable" v-model="producto.porcentajeContable2" />

                <br />
                <br />
                <el-select class="select-default select-account" v-model="producto.idCuenta3" filterable
                  :placeholder="$t('seleccioneUnaCuenta')">
                  <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account" :value="cuenta.id"
                    :label="
                      cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                    " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                  </el-option>
                </el-select>

                <input type="number" min="0" max="100" class="form-control col-md-1" style="display: inline !important;"
                  id="porcentajeContable" v-model="producto.porcentajeContable3" />
              </template>
            </v-tab>

            <v-tab v-if="configuradorPLU || tieneTspoonlab || tieneA3Software" :key="'tspoonlab'"
              :title="tieneA3Software ? 'A3Software' : 'PLUs'">
              
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 1</strong><strong v-else>PLU 1</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice1" v-bind:placeholder="$t('tarifa1')"
                        v-model="producto.namePrice1" disabled/>
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU1"></el-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 2</strong><strong v-else>PLU 2</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice2" v-bind:placeholder="$t('tarifa2')"
                        v-model="producto.namePrice2" disabled/>
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU2"></el-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 3</strong><strong v-else>PLU 3</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice3" v-bind:placeholder="$t('tarifa3')"
                        v-model="producto.namePrice3" disabled/>
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU3"></el-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 4</strong><strong v-else>PLU 4</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice4" v-bind:placeholder="$t('tarifa4')"
                        v-model="producto.namePrice4" disabled/>
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU4"></el-input>
                  </div>
                </div>
              </div>
            </v-tab>
            <br />
          </vue-tabs>

          <div class="row">
            <div class="col-md-12" style="margin-top: 10px">
              <button class="btn btn-primary" @click="idSector != 0 ? comprobarCodigoBarras() : saveProducto()"
                :disabled="inProgress">
                <i class="fa fa-check-square"></i> {{ $t("guardar") }}
              </button>
              <router-link :to="{
                name: 'productos',
                query: { filtro: filtro },
                params: { idBusiness: idBusiness, pag: pag },
              }">
                <button class="btn btn-danger">
                  <i class="fa fa-window-close"></i> {{ $t("cancelar") }}
                </button>
              </router-link>
              <el-checkbox v-model="checkReply" border class="checkbox-element" v-if="idSector == 0">
                {{ $t("replicar") }}
              </el-checkbox>

              <button v-if="idProducto && idSector == 0" class="btn btn-google" :disabled="inProgress"
                @click="clonarProducto">
                <i class="fas fa-exchange-alt"></i>
                {{ $t("clonarProducto") }}
              </button>

              <button :hidden="!tieneProductCarta || distinguirPrecios || checkReply" class="btn btn-info"
                @click="openModalReplicaCarta()" v-if="idSector == 0">
                <i class="fa fa-check-square"></i> {{ $t("guardaryreplicar") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="modal-copysub" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("copiarMateriaPrima") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          1 - {{ $t("seleccioneQueTipoDeMateriasPrimasQuiereCopiar") }}

          <el-checkbox-group v-model="listTipo" style="margin-top: 5px">
            <div class="col-md-12">
              <el-checkbox label="Bases" key="0"></el-checkbox>
              <el-checkbox label="Opcionales" key="1"></el-checkbox>
              <el-checkbox label="Extras" key="2"></el-checkbox>
            </div>
          </el-checkbox-group>

          <hr />

          2 - {{ $t("seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas") }}
          <el-checkbox-group v-model="listcategoriesCopySub" style="margin-top: 5px">
            <div class="col-md-12" v-for="c in listCategory">
              <el-checkbox :label="c.id" :key="c.id + '-' + c.name">
                {{ c.name }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="showModalCopySub()" class="btn btn-primary">
              <i class="fas fa-exchange-alt"></i> {{ $t("copiarMateriaPrima") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-replicar-carta" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("replicarencarta") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          {{ $t("deseaguardarelproductoencarta") }}
          <div class="col-md-12" style="padding-top: 20px">
            <el-checkbox label="check" key="" v-model="checkModalReply">{{
                $t("leidoyacepto")
            }}</el-checkbox>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModalReplicar()" class="btn btn-danger btnNoReplicar " :disabled="!checkModalReply">
              <i class="fa fa-window-close" style="padding-right : 10px;"></i>{{ $t("cancelar") }}
            </button>
            <button @click="saveProducto()" class="btn btn-primary btnReplicar" :disabled="!checkModalReply">
              <i class="fas fa-copy" style="padding-right : 10px;"></i>{{ $t("aceptarreplicarencarta") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modalagregarSubproducto" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("agregarMateriasPrimas") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          <div class="row">
            <div class="col-md-9">
              <input @keyup.enter.prevent="remoteMethod()" style="margin-bottom: 10px" type="text" class="form-control"
                id="buscadorSubproducts" :placeholder="$t('buscarMateriaPrima')" v-model="search" />
            </div>

            <div class="col-md-3">
              <button class="btn btn-primary" @click="remoteMethod()">
                <i class="fas fa-search"></i> {{ $t("buscarSinPuntos") }}
              </button>
            </div>
          </div>

          <el-checkbox-group :min="1" v-model="idsSubproductos" style="margin-top: 5px">
            <el-checkbox v-for="s in listSubproducts" :label="s.id" :key="s.id + '-' + s.name" border>
              {{ s.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button v-if="idsSubproductos.length !== 0" @click="agregarSubproductos()" class="btn btn-primary">
              <i class="fas fa-plus"></i> {{ $t("agregarMateriasPrimas") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-crear-subproductos" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <template>
        <div>
          <div class="modal-header">
            <h5>{{ $t("anyadirNuevoSubproducto") }}</h5>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("etiqueta") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idTag" filterable
                      :placeholder="$t('seleccioneEtiqueta')">
                      <el-option v-for="category in listEtiquetas" class="select-primary" :value="category.id"
                        :label="category.name" :key="category.id + '-' + category.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("proveedor") }}</strong></label>
                    <el-select class="select-default" size="large" v-model="subproducto.idSupplier" filterable
                      :placeholder="$t('seleccionaProveedor')">
                      <el-option v-for="proveedor in listProveedores" class="select-primary" :value="proveedor.id"
                        :label="proveedor.name" :key="proveedor.id + '-' + proveedor.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="nameCasaAgregar"><strong>{{ $t("nombreSubproducto") }} <span>*</span></strong></label>
                    <input type="text" class="form-control" :class="{
                      'is-valid':
                        subproducto.name.length > 0 &&
                        subproducto.name.length <= 50,
                      'is-invalid': subproducto.name.length > 50,
                    }" id="nameCasaAgregar" v-bind:placeholder="$t('introduzcaNombre')" v-model="subproducto.name"
                      ref="name" />
                    <input type="hidden" v-model="subproducto.xname" />
                    <small class="form-text text-muted">{{ subproducto.name.length }}/50
                    </small>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="codigodebarrasubproductoAgregar">
                      <strong>{{ $t("codigoBarra") }}</strong>
                    </label>
                    <input type="text" class="form-control" id="codigodebarrasubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="subproducto.codigoBarras" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="direccionsubproductoAgregar"><strong>{{ $t("descripcion") }}</strong></label>
                    <input type="text" class="form-control" id="direccionsubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaDescripcion')" v-model="subproducto.descripcion" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("tipo") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.tipo" filterable
                      :placeholder="$t('seleccionaTipo')">
                      <el-option v-for="tipo in listaTipoUn" class="select-primary" :value="tipo" :label="tipo"
                        :key="tipo + '- tipo'">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="escandalloSubproductoAgregar"><strong>{{ $t("escandallo") }}</strong></label>
                    <!--<input
                      type="number"
                      min="0"
                      class="form-control"
                      id="escandalloSubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaEscandallo')"
                      v-model="subproducto.escandallo"
                    />-->
                    <el-input-number id="escandalloSubproductoAgregar" v-model="subproducto.escandallo" :min="0"
                      :precision="0" :controls="false" :placeholder="$t('introduzcaEscandallo')">
                    </el-input-number>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("precioCompraSinIva") }}</strong></label>
                    <!--<input class="form-control" v-model="subproducto.precioCompraSinIva"-->
                    <!--type="number"-->
                    <!--id="precioCompraSubproductoSinIva"-->
                    <!--@change="calculatePrice(subproducto,false)"/>-->

                    <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                      currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, false)"
                      @keydown.native="$methods.evitarComasDecimales" v-model="subproducto.precioCompraSinIva">
                    </vue-numeric>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("tipoIva") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.tipoIva" filterable
                      @change="calculatePrice(subproducto, false)" :placeholder="$t('seleccionaIVA')">
                      <el-option v-for="iva in listIva" class="select-primary" :value="iva" :label="iva"
                        :key="iva + '- iva'">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="cuotaIVAAgregar"><strong>{{ $t("cuotaIVA") }}</strong></label>
                    <input class="form-control" :value="
                      (
                        subproducto.precioCompra -
                        subproducto.precioCompraSinIva
                      ).toFixed(2)
                    " type="number" disabled id="cuotaIVAAgregar" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("precioCompraConIva") }}</strong></label>
                    <!--<input class="form-control" v-model="subproducto.precioCompra"-->
                    <!--type="number"-->
                    <!--id="precioCompraSubproducto"-->
                    <!--@keyup="calculatePrice(subproducto,true)"/>-->
                    <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                      currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, true)"
                      @keydown.native="$methods.evitarComasDecimales" v-model="subproducto.precioCompra"></vue-numeric>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="descuentoCompraSubproductoAgregar"><strong>{{ $t("descuentoCompra")
                    }}</strong></label><span style="font-size: x-small">
                      {{ $t("porcentaje") }}</span>
                    <input type="number" min="0" class="form-control" id="descuentoCompraSubproductoAgregar"
                      placeholder="0%" v-model="subproducto.descuentoCompra" />
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class="col-md-6" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("baja") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("guardarEnAlmacen") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.guardarAlmacen" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="stockMinimoSubproductoAgregar"><strong>{{ $t("stockMinimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockMinimoSubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaStockMinimo')" v-model="subproducto.stockMinimo" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="stockOptimoSubproductoAgregar"><strong>{{ $t("stockOptimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockOptimoSubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaStockOptimo')" v-model="subproducto.stockOptimo" />
                  </div>
                </div>
                <div v-if="listCuentasGastosSage.length > 1" class="col-md-12">
                  <hr />
                  <label><strong>{{ tieneDimoni ? $t('enlaceContable') : $t('sage200') }}</strong></label>
                  <br />
                  <label>{{ $t("aContinuacionSeListaranLasCuentasDeTipo") }}
                    <strong>{{ $t("gastoMinuscula") }}</strong>
                    {{ $t("paraQue") }}
                    <strong>{{ $t("asocieMinuscula") }}</strong>
                    {{ $t("unaParaSuPosterior") }}
                    <strong>{{ tieneDimoni ? $t('relacionEnContabilidad') : $t('relacionEnSage') }}</strong></label>
                  <br />
                  <el-select class="select-default select-account" v-model="subproducto.idCuenta"
                    :placeholder="$t('seleccioneUnaCuenta')">
                    <el-option v-for="cuenta in listCuentasGastosSage" class="select-primary" :value="cuenta.id" :label="
                      cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                    " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                    </el-option>
                  </el-select>
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="saveSubproducto(idProducto)" class="btn btn-primary">
              <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
            </button>
          </div>
        </div>
      </template>
    </modal>

    <modal name="modalReply" :adaptive="true" :scrollable="true" height="auto" width="50%" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarProducto") }}</h4>
        </div>

        <div class="modal-body">
          <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
            @click="selectAll" />
          <label for="checkSelectAll" class="checkSelectAll">{{
              $t("seleccionarTodos")
          }}</label>

          <div v-for="business in listBusinesses">
            <div class="row">
              <div class="col-md-6">
                <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border class="checkbox-element"
                  style="width: 100%;margin-left: 2%">
                  {{ business.establishmentName }}
                </el-checkbox>
              </div>
              <div class="col-md-6">
                <el-select v-if="business.id != idBusiness" class="select-default" size="large"
                  :disabled="!business.checked" style="width: 100%;margin-left: 2%" v-model="business.idCategory"
                  :placeholder="$t('seleccionaUnaCategoria')">
                  <el-option v-for="c in business.categories" class="select-primary" :value="c.id" :label="c.name"
                    :key="c.id + '-' + c.name">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="closeModal()">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          
          <button v-if="producto.wasMenu == true" class="btn btn-primary" @click="openModalreplymenu()">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
          <button v-else class="btn btn-primary" @click="replyProduct">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <modal name="modalReplyMenu" :adaptive="true" :scrollable="true" height="auto" width="40%" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarProducto") }}</h4>
        </div>
        
        <div class="modal-body">
          <vue-tabs @tab-change="handleTabChange2" v-model="tabs">
          <template v-for="business in businessListPlatos">
            <v-tab :key="business.id"  v-if="business.checked" :title="business.establishmentName">
            <vue-tabs v-model="tabs">
              <template  v-for="(plato) in business.listaPlatos2">
              <v-tab :key="plato.id"  :title="plato.plato">
                <div v-for="productor in plato.products" :key="productor.id">
                  <div class="row">
                    <div class="col-md-6">
                      <el-label  style="width: 100%;margin-left: 2%">
                        {{ productor.name }}
                      </el-label>
                    </div>
                    <div class="col-md-6">
                      <el-select v-model="productor.idCategory" class="select-default" size="large"
                      style="width: 100%;margin-left: 2%" 
                      :placeholder="$t('seleccionaUnaCategoria')">
                      <el-option :key="c.id" v-for="c in business.categories"  class="select-primary" :value="c.id" :label="c.name">
                      </el-option>
                    </el-select>
                    </div>
                  </div>
                </div>
              </v-tab>
            </template>
            </vue-tabs>
          </v-tab>
          </template>
          </vue-tabs>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="closeModal()">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-primary" @click="checkCategory()">
            <!-- replyProduct -->
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { mapState } from "vuex";
import { Loading } from "element-ui";
import draggable from "vuedraggable";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup,
  InputNumber,
  Input,
  Switch,
} from "element-ui";
import { VBModal } from 'bootstrap-vue';
import { forEach } from 'mathjs';


export default {
  props: ["idBusiness", "idProducto", "pag", "filtro", "idSectorParam"],

  created() {
    this.action = this.idProducto
      ? this.$i18n.t("editar")
      : this.$i18n.t("nuevo");

    this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
    this.getIdTpvByBusiness();
    this.getIva();
    this.getCategory();
    this.getPlanos();
    this.getPrinters();
    this.identificacionNegocio();
    this.getConfigDimoni();
    this.getIsRetail();
    this.getConfigTspoonlab();
    this.getConfigConfiguradorPLU();
    this.getConfigA3Software();
    this.searchProductInProductCarta(this.idProducto);

    //Si estamos editando, consigue el producto y sus subproductos
    if (this.idProducto) {
      this.getProducto();
      this.getSubproductByProduct();

      this.peticionesFinSpiner = 6;
    } else {
      this.peticionesFinSpiner = 4;
    }

    //Si tiene sector
    if (this.idSectorParam) {
      this.idSector = this.idSectorParam;
    }

    //Si tiene config de distinguir precios de la carta
    this.getConfigDistinguirPrecios();

  },
  updated() {
    this.nPeticiones++;

    if (this.idProducto) {
      if (this.nPeticiones === this.peticionesFinSpiner) {
        this.loadingGeneral.close();
      }
    } else {
      if (this.nPeticiones === this.peticionesFinSpiner) {
        this.loadingGeneral.close();
      }
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [InputNumber.name]: InputNumber,
    [CheckboxGroup.name]: CheckboxGroup,
    [Input.name]: Input,
    draggable,
  },
  mounted() {
    this.$refs.name.focus();
  },
  data() {
    return {
      //PRUEBAS INICIO PAGINA
      listSubproductosPlatos: [],
      loadingGeneral: null,
      peticionesFinSpiner: 0,
      nPeticiones: 0,
      distinguirPrecios: false,
      tieneProductCarta: false,
      listPlanos: [],
      producto: {
        id: 0,
        orden: 999,
        idCategory: 0,
        tipoIva: 10,
        xname: "",
        nombreProducto: "",
        precioCoste: 0,
        precioCosteSinIVA: 0,
        precioCoste2: 0,
        precioCosteSinIVA2: 0,
        precioCoste3: 0,
        precioCosteSinIVA3: 0,
        precioCoste4: 0,
        precioCosteSinIVA4: 0,
        descripcion: "",
        codigoBarras: "",
        color: "amarillo",
        baja: false,
        descuento: false,
        selPrice1: false,
        selPrice2: false,
        selPrice3: false,
        selPrice4: false,
        namePrice1: "",
        namePrice2: "",
        namePrice3: "",
        namePrice4: "",
        numOpcionales: 0,
        price1: 0,
        price2: 0,
        price3: 0,
        price4: 0,

        printerName: this.$t("ningunaSeleccionada"),
        printerPDAName: this.$t("ningunaSeleccionada"),
        printerName2: this.$t("ningunaSeleccionada"),
        printerPDAName2: this.$t("ningunaSeleccionada"),

        impresionPlano1: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano1: this.$t("ningunaSeleccionada"),
        impresionPlano2: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano2: this.$t("ningunaSeleccionada"),
        impresionPlano3: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano3: this.$t("ningunaSeleccionada"),
        impresionPlano4: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano4: this.$t("ningunaSeleccionada"),
        impresionPlano5: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano5: this.$t("ningunaSeleccionada"),
        impresionPlano6: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano6: this.$t("ningunaSeleccionada"),
        impresionPlano7: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano7: this.$t("ningunaSeleccionada"),
        impresionPlano8: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano8: this.$t("ningunaSeleccionada"),

        impresionPlanoKDS1: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS1: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS2: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS2: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS3: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS3: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS4: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS4: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS6: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS6: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS7: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS7: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS8: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS8: this.$t("ningunaSeleccionada"),

        impresionKDSTPV: this.$t("ningunaSeleccionada"),
        copiaImpresionKDSTPV: this.$t("ningunaSeleccionada"),
        impresionKDSPDA: this.$t("ningunaSeleccionada"),
        copiaImpresionKDSPDA: this.$t("ningunaSeleccionada"),

        precio: false,
        opcion1: "",
        opcion2: "",
        opcion3: "",
        opcion4: "",
        opcion5: "",
        peso: false,
        importe: false,
        promocionable: false,
        mostrarPC: true,
        mostrarPDA: true,
        noImprimir: false,
        seleccionarIngredientes: false,
        numPlato: 0,
        subproductos: [],
        idCuenta: "0",
        porcentajeContable: 0,
        idCuenta2: "0",
        porcentajeContable2: 0,
        idCuenta3: "0",
        porcentajeContable3: 0,
        isMenu: 0,
        PLU1: "",
        PLU2: "",
        PLU3: "",
        PLU4: ""
        //isClosed: false, //menu cerrado
      },
      isClosed: false,
      checkSelectAll: false,
      listBusinesses: [],
      checkReply: false,
      maxNameProducts: 50,
      action: "",
      inProgress: false,
      listaTipoIva: [0, 4, 10, 21],
      listCategory: [],
      listPrinter: [],
      listKds: [],
      nombreNegocio: "",
      listaTipo: [
        { label: this.$t("base"), value: "B" },
        { label: this.$t("extra"), value: "E" },
        { label: this.$t("opcional"), value: "O" },
      ],
      tipoAnterior: "",

      listSubproductosByProducts: [],
      listSubproducts: [],
      search: "",
      checkModalReply: false,

      listaTipoUn: [
        this.$t("uds"),
        this.$t("cajas"),
        this.$t("botellas"),
        this.$t("barriles"),
        this.$t("palets"),
        this.$t("bolsas"),
        "Kgs",
        this.$t("litros"),
        this.$t("rollos"),
      ],

      loading: false,
      idsSubproductos: [],

      listIva: [],

      listProveedores: [],
      listEtiquetas: [],
      listCasas: [],

      subproducto: {
        idTag: 0,
        idSupplier: 0,
        idCasa: 0,
        name: "",
        xname: "",
        descripcion: "",
        codigoBarras: "",
        tipo: "Uds.",
        tipoIva: 10,
        descuentoCompra: 0,
        precioCompra: 0,
        precioCompraSinIva: 0,
        escandallo: 1,
        stockMinimo: 0.0,
        stockMinimoPartes: 0.0,
        stockOptimo: 0.0,
        color: "amarillo",
        guardarAlmacen: true,
        baja: false,
        idCuenta: "0",
        noMostrarInformeSectores: 0
      },
      maxNameSubproducto: 50,
      tabs: 0,
      mostrarAsociar: false,

      ordenarSubproduct: false,

      //COPY SUB
      listcategoriesCopySub: [],
      listTipo: [],

      //DESCARGAR ETIQUETAS
      numEtiquetas: 1,

      idTpv: "",
      listCuentasSage: [],
      listCuentasGastosSage: [],

      //MENU
      isMenu: false,
      action: "",
      idMenu: this.$route.params.idMenu,
      idCarta: this.$route.params.idCarta,
      menu: {
        idCategoria: 0,
        idProduct: "",
        idProductCarta: "",
        nombre: "",
        descripcion: "",
        imagen: "",
        tipoCarta: "",
        numeroPrimeros: 0,
        numeroSegundos: 0,
        numeroTerceros: 0,
        numeroCuartos: 0,
        numeroQuintos: 0,
        numeroSextos: 0,
        nombreTarifa1: "",
        precioTarifa1: 0,
        nombreTarifa2: "",
        precioTarifa2: 0,
        nombreTarifa3: "",
        precioTarifa3: 0,
        nombreTarifa4: "",
        precioTarifa4: 0,
        updated: "",
        orden: 999,
        noDisponible: false,
        baja: false,
      },

      listCategories: [],
      listProductos: [],
      listPlatos: [],
      listCategoriaMenu: [],
      listProductosTodos: [],
      img: "",

      listTipoProducto: [
        {
          value: "",
          label: this.$t("todos"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
      ],

      //MATERIAS PRIMAS
      listaTipo: [
        { label: this.$t("base"), value: "B" },
        { label: this.$t("extra"), value: "E" },
        { label: this.$t("opcional"), value: "O" },
      ],
      listMateriasPrimas: [],
      listSearchMateriasPrimas: [],
      idMateriaPrima: "",
      tipoAnterior: "",

      listTipo: [],
      listcategoriesCopySub: [],
      nombreMenu: "",
      loading: "",
      editandoPrimero: false,
      editandoSegundo: false,
      editandoTercero: false,
      editandoCuarto: false,
      editandoQuinto: false,
      editandoSexto: false,
      primerPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 1,
      },
      segundoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 2,
      },
      tercerPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 3,
      },
      cuartoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 4,
      },
      quintoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 5,
      },
      sextoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 6,
      },
      platoSeleccionado: 0,
      productoSeleccionado: null,
      listProductosPlato: [],
      listProductosPlatoId: [],

      menu: {
        plato1: "",
        plato2: "",
        plato3: "",
        plato4: "",
        plato5: "",
        plato6: "",
      },

      platos: [
        { nombrePlato: "", idPlato: 1 },
        { nombrePlato: "", idPlato: 2 },
        { nombrePlato: "", idPlato: 3 },
        { nombrePlato: "", idPlato: 4 },
        { nombrePlato: "", idPlato: 5 },
        { nombrePlato: "", idPlato: 6 },
      ],

      listaPlatos: [],

      nombrePlatoInsert: "",

      idSector: 0,

      tieneDimoni: false,

      categoryList:[],
      businessListPlatos:[],
      idCategoryProductoPlato: 0,
      tieneTspoonlab: false,
      tieneA3Software: false,
      configuradorPLU: false,

      //Modos
      listModos: [],

      //isRetail
      isRetail: false,

      //isExtraAverageChecked
      isExtraAverageChecked: false
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.idProducto) {
        this.idProducto = to.params.idProducto;
        this.getProducto();
        this.getSubproductByProduct();

      }

      if (to.params.idSector) {
        this.idSector = to.params.idSector;
      }

      if (this.idSectorParam);
      {
        this.idSector = this.idSectorParam;
      }
    },
    platoSeleccionado: function (newVal, oldVal) {

      this.listProductosPlatoId = [];

      this.productoSeleccionado = null;

      if (this.isClosed) {
        this.getProductsMenuCerrado();
      } else {
        this.getProductosByPlato();
      }

    },
    "menu.nombre": function (newVal, oldVal) {
      this.nombreMenu = newVal;
    },
  },
  computed: {
    ...mapState(["sectores", "listaSectores"]),
  },
  methods: {
    getConfigDimoni() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 83,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneDimoni = true;
          } else {
            vm.tieneDimoni = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getIsRetail() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getIsRetail",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.isRetail = true;
          } else {
            vm.isRetail = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigTspoonlab() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 112,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneTspoonlab = true;
          } else {
            vm.tieneTspoonlab = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigConfiguradorPLU() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 117,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.configuradorPLU = true;
          } else {
            vm.configuradorPLU = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigA3Software() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 113,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneA3Software = true;
          } else {
            vm.tieneA3Software = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigDistinguirPrecios() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 55,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function (response) {
          if (response.data.response) {
            vm.distinguirPrecios = true;
          } else {
            vm.distinguirPrecios = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cerrarModalReplicar() {
      this.$modal.hide("modal-replicar-carta");
    },
    cargarCuentasPorIdTpv() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/getSageBusinessDataByIdTpv",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCuentasSage.push({
              id: "0",
              codigoCuenta: "0",
              codigoSubCuenta: "",
              nombreCuenta: vm.$t("sinCuentaAsociada"),
            });
            vm.listCuentasGastosSage.push({
              id: "0",
              codigoCuenta: "0",
              codigoSubCuenta: "",
              nombreCuenta: vm.$t("sinCuentaAsociada"),
            });
            response.data.result.forEach((cuenta) => {
              if (cuenta.tipo == "B") {
                vm.listCuentasSage.push(cuenta);
              } else if (cuenta.tipo == "G") {
                vm.listCuentasGastosSage.push(cuenta);
              }
            });
            //vm.listCuentasSage = response.data.result;

            vm.respuesta = true;
          }
          vm.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getModosPorIdTpv() {
      var config = {
        params: {
          idTpv: this.idTpv,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getModosProducts",
          config
        )
        .then(function (response) {
          if (response.data.response) {

            vm.listModos = response.data.result;

          }
          vm.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeTipo(entrada, producto) {
      var constError = 0;

      if (entrada === 1) {
        if (this.tipoAnterior === "") {
          this.tipoAnterior = producto.tipo;
        } else {
          this.tipoAnterior = "";
        }
      } else {
        this.listSubproductosByProducts.forEach(function (x) {
          if (
            x.idSubproduct === producto.idSubproduct &&
            x.tipo === producto.tipo
          ) {
            constError++;
          }
        });

        if (constError > 1) {
          producto.tipo = this.tipoAnterior;

          swal({
            title: this.$t("atencion"),
            text: this.$t("noPuedeHaberDosMateriasPrimasConElMismoTipo"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        }
      }
    },

    handleTabChange(tabIndex, newTab, oldTab) {
      if (newTab.id == "3") {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
        this.peticionesFinSpiner = 2;
        this.nPeticiones = 0;

        this.getCasas();
        this.getProveedores();

        this.getEtiquetas();
      }
    },

    handleTabChange2(tabIndex, newTab, oldTab) {
      console.log(this.businessListPlatos[tabIndex]);
    },
    /*descargarCodigos() {


                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                var params = {
                    idProduct: this.idProducto,
                    numEtiquetas: this.numEtiquetas,

                    jwt: this.$store.getters.jwt
                };

                let vm = this;
                let controller = "downloadBarCode";
                this.axios.post(this.$store.getters.apiUrl + 'products/' + controller, params, config)
                    .then(function (response) {

                        if (response.data.response) {

                            let notify = "descargadas";
                            vm.$notify({
                                message: 'Etiquetas ' + notify + ' correctamente',
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });


                        } else {
                            swal({
                                title: `Atención`,
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            },*/

    openModalNuevoSubproducto() {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      this.peticionesFinSpiner = 2;
      this.nPeticiones = 0;

      this.getCasas();
      this.getProveedores();
      this.getEtiquetas();

      this.$modal.show("modal-crear-subproductos");
    },


    getPlanos() {

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios.get(this.$store.getters.apiUrl + "online/getPlanos", config)
        .then(function (response) {
          if (response.data.response) {

            vm.listPlanos = response.data.result.salones;
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCasas() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getCasasByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let casas = {
                name: vm.$t("sinCasas"),
                id: 0,
              };

              vm.listCasas.push(casas);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let casas = {
                  name: vm.$t("sinCasas"),
                  id: 0,
                };

                vm.listCasas.push(casas);
              }

              let casasname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listCasas.push(casasname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
     getSubproductsByProductsMenu() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getSubproductsByProductsMenu",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproductosPlatos = response.data.result

            vm.listSubproductosPlatos.forEach((plato) => {

              plato.products.forEach((product) => {

                product.subproducts.forEach((subproduct) => {
                  const newPrice = parseFloat(
                    subproduct.precioCompra / ((100 + subproduct.iva) / 100)
                  );
                  subproduct.precioCompraSinIva = newPrice;
                });

              });

            });

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    calcularCosto(sinIva, isExtraAverageChecked) {
      let total = 0;
      let totalOpcionales = 0;
      let numOpcionales = 0;
      let totalExtras = 0;
      
      let vm = this;
      if (this.producto.isMenu) {
        //Preparamos la carga, ya que vamos a recoger todos los productos asociados con el menu
        if (this.listSubproductosPlatos.length > 0) {
        
          this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

          //Si es sin IVA
          if (sinIva) {
            this.producto.precioCosteSinIVA = 0;

            //Recorremos los platos
            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;

              //Recorremos sus productos
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;

                //Recorremos sus subproductos
                product.subproducts.forEach(function (x) {
                  if (x.tipo === "B") {
                    totalProducto += vm.getPrecioCompraSinIVA(x, true);
                  }

                  if (x.tipo === "O") {
                    numOpcionalesProducto++;
                    totalOpcionalesProducto += vm.getPrecioCompraSinIVA(x, true);
                  }

                  if (isExtraAverageChecked && x.tipo === "E") { 
                    let vecesVendidas = x.veces_vendido_extra;
                    let precioExtra = vm.getPrecioCompraSinIVA(x, true);
                    if (vecesVendidas != 0) {
                      totalExtras += precioExtra / vecesVendidas;
                    }
                  }
                });

                //Calculamos el precio del producto
                if (numOpcionalesProducto === 0) {
                  product.precioCosteSinIVA = totalProducto;
                } else {
                  product.precioCosteSinIVA =
                    totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                }

                //Vamos sumando al total del plato
                totalPlato += product.precioCosteSinIVA;
              });

              console.log("TOTAL EXTRAS PT3: " + totalExtras);
              let mediaTotal = totalPlato + totalExtras;
              //Una vez que ya no quedan más productos, dividimos el total del plato por el número de productos para sacar la media
              if (!vm.isClosed) {
                mediaTotal = totalPlato / plato.numeroPlatos;
              }

              //Con la media, sumaremos al total del menú
              total += mediaTotal;
            });

            this.producto.precioCosteSinIVA = total;

            this.loadingGeneral.close();

          } else {
            this.producto.precioCoste = 0;

            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;

              //Recorremos sus productos
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;

                product.subproducts.forEach(function (x) {

                  if (x.tipo === "B") {
                    totalProducto += vm.getPrecioCompra(x, true);
                  }

                  if (x.tipo === "O") {
                    numOpcionalesProducto++;
                    totalOpcionalesProducto += vm.getPrecioCompra(x, true);
                  }

                  if (isExtraAverageChecked && x.tipo === "E") {
                    let vecesVendidas = x.veces_vendido_extra;
                    let precioExtra = vm.getPrecioCompra(x, true);
                    if (vecesVendidas != 0) {
                      totalExtras += precioExtra / vecesVendidas;
                    }
                  }
                });

                //Calculamos el precio del producto
                if (numOpcionalesProducto === 0) {
                  product.precioCoste = totalProducto;
                } else {
                  product.precioCoste =
                    totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                }

                //Vamos sumando al total del plato
                totalPlato += product.precioCoste;

              });

              let mediaTotal = totalPlato + totalExtras;
              //Una vez que ya no quedan más productos, dividimos el total del plato por el número de productos para sacar la media
              if (!vm.isClosed) {
                mediaTotal = totalPlato / plato.numeroPlatos;
              }

              //Con la media, sumaremos al total del menú
              total += mediaTotal;

            });

            this.producto.precioCoste = total;

            this.loadingGeneral.close();
          }

        }

      } else {

        //Comprobamos qué campo se quiere calcular
        if (sinIva) {
          this.producto.precioCosteSinIVA = 0;

          //Llamamos a las respectivas funciones
          this.listSubproductosByProducts.forEach(function (x) {
            if (x.tipo === "B") {
              total += vm.getPrecioCompraSinIVA(x, true);
            }

            if (x.tipo === "O") {
              numOpcionales++;
              totalOpcionales += vm.getPrecioCompraSinIVA(x, true);
            }

            if (isExtraAverageChecked && x.tipo === "E") {
              let vecesVendidas = x.veces_vendido_extra;
              let precioExtra = vm.getPrecioCompraSinIVA(x, true);
              if (vecesVendidas != 0) {
                totalExtras += precioExtra / vecesVendidas;
              }
            }
          });

          //Calculamos en función de los opcionales
          if (numOpcionales === 0) {
            this.producto.precioCosteSinIVA = total + totalExtras;;
          } else {
            this.producto.precioCosteSinIVA =
              total + totalOpcionales / numOpcionales + totalExtras;;
          }
        } else {
          
          this.producto.precioCoste = 0;

          //Llamamos a las respectivas funciones
          this.listSubproductosByProducts.forEach(function (x) {
            if (x.tipo === "B") {
          
              total += vm.getPrecioCompra(x, true);
            }
            
            if (x.tipo === "O") {
              numOpcionales++;
              totalOpcionales += vm.getPrecioCompra(x, true);
            }

            if (isExtraAverageChecked && x.tipo === "E") {
              let vecesVendidas = x.veces_vendido_extra;
              let precioExtra = vm.getPrecioCompra(x, true);
              if (vecesVendidas != 0) {
                totalExtras += precioExtra / vecesVendidas;
              }
            }
          });

          //Calculamos en función de los opcionales
          if (numOpcionales === 0) {
            this.producto.precioCoste = total + totalExtras;
          } else {
            this.producto.precioCoste = total + totalOpcionales / numOpcionales + totalExtras;
          }
        }
      }
    },
    calcularCostoTarifas(tarifa, sinIva) {
      let total = 0;
      let totalOpcionales = 0;
      let numOpcionales = 0;


      let vm = this;
      
      if (this.producto.isMenu) {
        //Preparamos la carga, ya que vamos a recoger todos los productos asociados con el menu
        if (this.listSubproductosPlatos.length > 0) {

          this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

          //Si es sin IVA
          if (sinIva) {

            switch (tarifa) {
              case 2:
                this.producto.precioCosteSinIVA2 = 0;
                break;
              case 3:
                this.producto.precioCosteSinIVA3 = 0;
                break;
              case 4:
                this.producto.precioCosteSinIVA4 = 0;
                break;
            }

            //Recorremos los platos
            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;

              //Recorremos sus productos
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;

                //Recorremos sus subproductos
                product.subproducts.forEach(function (x) {
                  if (x.tipo === "B") {
                    totalProducto += vm.getPrecioCompraSinIVATarifas(x, true);
                  }

                  if (x.tipo === "O") {
                    numOpcionalesProducto++;
                    totalOpcionalesProducto += vm.getPrecioCompraSinIVATarifas(x, true);
                  }
                });

                //Calculamos el precio del producto

                //Vamos sumando al total del plato
                switch (tarifa) {
                  case 2:

                    if (numOpcionalesProducto === 0) {
                      product.precioCosteSinIVA2 = totalProducto;
                    } else {
                      product.precioCosteSinIVA2 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCosteSinIVA2;
                    break;
                  case 3:

                    if (numOpcionalesProducto === 0) {
                      product.precioCosteSinIVA3 = totalProducto;
                    } else {
                      product.precioCosteSinIVA3 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCosteSinIVA3;
                    break;
                  case 4:

                    if (numOpcionalesProducto === 0) {
                      product.precioCosteSinIVA4 = totalProducto;
                    } else {
                      product.precioCosteSinIVA4 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCosteSinIVA4;
                    break;
                }

              });

              let mediaTotal = totalPlato;
              //Una vez que ya no quedan más productos, dividimos el total del plato por el número de productos para sacar la media
              if (!vm.isClosed) {
                mediaTotal = totalPlato / plato.numeroPlatos;
              }

              //Con la media, sumaremos al total del menú
              total += mediaTotal;
            });

            switch (tarifa) {
              case 2:
                this.producto.precioCosteSinIVA2 = total;
                break;
              case 3:
                this.producto.precioCosteSinIVA3 = total;
                break;
              case 4:
                this.producto.precioCosteSinIVA4 = total;
                break;
            }


            this.loadingGeneral.close();

          } else {

            let tarifaElegida = 2;

            switch (tarifa) {
              case 2:
                this.producto.precioCoste2 = 0;
                tarifaElegida = 2;
                break;
              case 3:
                this.producto.precioCoste3 = 0;
                tarifaElegida = 3;
                break;
              case 4:
                this.producto.precioCoste4 = 0;
                tarifaElegida = 4;
                break;
            }

            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;

              //Recorremos sus productos
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;

                product.subproducts.forEach(function (x) {

                  if (x.tipo === "B") {
                    totalProducto += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
                  }

                  if (x.tipo === "O") {
                    numOpcionalesProducto++;
                    totalOpcionalesProducto += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
                  }
                });

                switch (tarifa) {
                  case 2:

                    if (numOpcionalesProducto === 0) {
                      product.precioCoste2 = totalProducto;
                    } else {
                      product.precioCoste2 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCoste2;
                    break;
                  case 3:

                    if (numOpcionalesProducto === 0) {
                      product.precioCoste3 = totalProducto;
                    } else {
                      product.precioCoste3 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCoste3;
                    break;
                  case 4:

                    if (numOpcionalesProducto === 0) {
                      product.precioCoste4 = totalProducto;
                    } else {
                      product.precioCoste4 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCoste4;
                    break;
                }

              });

              let mediaTotal = totalPlato;
              //Una vez que ya no quedan más productos, dividimos el total del plato por el número de productos para sacar la media
              if (!vm.isClosed) {
                mediaTotal = totalPlato / plato.numeroPlatos;
              }

              //Con la media, sumaremos al total del menú
              total += mediaTotal;

            });

            switch (tarifa) {
              case 2:
                this.producto.precioCoste2 = total;
                break;
              case 3:
                this.producto.precioCoste3 = total;
                break;
              case 4:
                this.producto.precioCoste4 = total;
                break;
            }

            this.loadingGeneral.close();
          }

        }

      } else {
        //sin iva
        let tarifaElegida = 2;
        switch (tarifa) {
          case 2:
            this.producto.precioCoste2 = 0;
            tarifaElegida = 2;
            break;
          case 3:
            this.producto.precioCoste3 = 0;
            tarifaElegida = 3;
            break;
          case 4:
            this.producto.precioCoste4 = 0;
            tarifaElegida = 4;
            break;
        }
        //fin sin iva
        //Comprobamos qué campo se quiere calcular
        if (sinIva) {
          switch (tarifa) {
            case 2:
              this.producto.precioCosteSinIVA2 = 0;
              break;
            case 3:
              this.producto.precioCosteSinIVA3 = 0;
              break;
            case 4:
              this.producto.precioCosteSinIVA4 = 0;
              break;
          }

          //Llamamos a las respectivas funciones
          this.listSubproductosByProducts.forEach(function (x) {
            if (x.tipo === "B") {
              total += vm.getPrecioCompraSinIVATarifas(x, true, tarifaElegida);
            }

            if (x.tipo === "O") {
              numOpcionales++;
              totalOpcionales += vm.getPrecioCompraSinIVATarifas(x, true, tarifaElegida);
            }
          });

          //Calculamos en función de los opcionales

          switch (tarifa) {
            case 2:

              if (numOpcionales === 0) {
                this.producto.precioCosteSinIVA2 = total;
              } else {
                this.producto.precioCosteSinIVA2 =
                  total + totalOpcionales / numOpcionales;
              }

              break;
            case 3:

              if (numOpcionales === 0) {
                this.producto.precioCosteSinIVA3 = total;
              } else {
                this.producto.precioCosteSinIVA3 =
                  total + totalOpcionales / numOpcionales;
              }

              break;
            case 4:

              if (numOpcionales === 0) {
                this.producto.precioCosteSinIVA4 = total;
              } else {
                this.producto.precioCosteSinIVA4 =
                  total + totalOpcionales / numOpcionales;
              }

              break;
          }
        } else {
          let tarifaElegida = 2;
          switch (tarifa) {
            case 2:
              this.producto.precioCoste2 = 0;
              tarifaElegida = 2;
              break;
            case 3:
              this.producto.precioCoste3 = 0;
              tarifaElegida = 3;
              break;
            case 4:
              this.producto.precioCoste4 = 0;
              tarifaElegida = 4;
              break;
          }

          //Llamamos a las respectivas funciones
          this.listSubproductosByProducts.forEach(function (x) {
            if (x.tipo === "B") {
              total += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
            }

            if (x.tipo === "O") {
              numOpcionales++;
              totalOpcionales += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
            }
          });

          //Calculamos en función de los opcionales


          switch (tarifa) {
            case 2:

              if (numOpcionales === 0) {
                this.producto.precioCoste2 = total;
              } else {
                this.producto.precioCoste2 = total + totalOpcionales / numOpcionales;
              }

              break;

            case 3:

              if (numOpcionales === 0) {
                this.producto.precioCoste3 = total;
              } else {
                this.producto.precioCoste3 = total + totalOpcionales / numOpcionales;
              }

              break;

            case 4:

              if (numOpcionales === 0) {
                this.producto.precioCoste4 = total;
              } else {
                this.producto.precioCoste4 = total + totalOpcionales / numOpcionales;
              }

              break;
          }
        }
      }

    },
    getProveedores() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getSuppliersByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinProveedores"),
                id: 0,
              };

              vm.listProveedores.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let proveedor = {
                  name: vm.$t("sinProveedores"),
                  id: 0,
                };

                vm.listProveedores.push(proveedor);
              }

              let proveedorname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listProveedores.push(proveedorname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getEtiquetas() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinEtiqueta"),
                id: 0,
              };

              vm.listEtiquetas.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let category = {
                  name: vm.$t("sinEtiqueta"),
                  id: 0,
                };

                vm.listEtiquetas.push(category);
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listEtiquetas.push(categoryname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getIva() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getIvaByTpv", config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result) {
              response.data.result.forEach((iva) => {

                if (!vm.listIva.includes(iva)) vm.listIva.push(iva);
              })
            } else {
              vm.listIva = false;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    agregarSubproductos() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let controller;

      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      var params = {
        idsSubproductos: this.idsSubproductos,
        idBusiness: this.idBusiness,
        idProduct: this.idProducto,

        jwt: this.$store.getters.jwt,
      };

      controller = "saveSubproductByProduct";

      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.loadingGeneral.close();

            let notify = vm.$t("agregadas");
            vm.$notify({
              message:
                vm.$t("materiasPrimas") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modalagregarSubproducto");
            vm.idsSubproductos = [];
            vm.getSubproductByProduct();
            vm.search = "";
            vm.listSubproducts = [];
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    remoteMethod(query) {
      let busqueda = this.search;

      this.loading = true;

      const controller = "searchSubproductsByProduct/" + this.search;

      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproducts = response.data.result.listSubproduct;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openModalCopiarSub() {
      this.$modal.show("modal-copysub");
    },
    openModalReplicaCarta() {
      this.$modal.show("modal-replicar-carta");
    },

    openModalAgregarSubproducto() {
      this.$modal.show("modalagregarSubproducto");
    },

    getSubproductByProduct() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getSubproductByProduct",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproductosByProducts = response.data.result;
            vm.listSubproductosByProducts.forEach((subproduct) => {
              const newPrice = parseFloat(
                subproduct.precioCompra / ((100 + subproduct.iva) / 100)
              );
              subproduct.precioCompraSinIva = newPrice;
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    eliminarSubproducto(p) {
      swal({
        title: this.$t("estasSeguroDeBorrarLaMateriaPrima"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siDeseoBorrarlo"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.eliminarSubproduct(p);
        }
      });
    },

    editSubproduct() {
      let vm = this;

      this.listSubproductosByProducts.forEach(function (x) {
        if (x.tipo === "O") {
          if (vm.producto.numOpcionales === 0) {
            vm.producto.numOpcionales = 1;
          }
        }

        if (x.tipo === "E") {
          vm.producto.seleccionarIngredientes = true;
        }
      });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let controller;

      //TODO FALTA TESTEAR
      var params = {
        listSubproducts: this.listSubproductosByProducts,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        idProduct: this.idProducto,
      };

      controller = "editSubproductByProduct";

      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.loadingGeneral.close();

            let notify = vm.$t("modificadas");

            vm.$notify({
              message:
                vm.$t("materiasPrimas") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    eliminarSubproduct(p) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        subproduct: p,
        idProduct: this.idProducto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "deleteSubproductByProduct";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaEliminadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.getSubproductByProduct();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    identificacionNegocio() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/identifyBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.nombreNegocio = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    checkCampos() {
      if (this.producto.nombreProducto.length > this.maxNameProducts) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
            this.maxNameProducts +
            ".",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else if (
        this.producto.nombreProducto === null ||
        this.producto.nombreProducto.length === 0
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },

    getCategory() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getCategoryByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              vm.listCategory.push(category);
            } else {
              if (!vm.idProducto) {
                vm.producto.idCategory = response.data.result[0].id;
              }
              for (let i = 0; i < response.data.result.length; i++) {
                let category = {
                  name: response.data.result[i].name,
                  id: response.data.result[i].id,
                };

                vm.listCategory.push(category);
              }
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getProducto() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/getProductById", config)
        .then(function (response) {
          if (response.data.response) {
            vm.producto = response.data.result;

            //Si tiene menu
            if (vm.producto.isMenu == 1) {
              vm.producto.isMenu = true;
              vm.producto.wasMenu = true;
              //Lo consigue y consigue los subproductos
              vm.getMenuById();
              vm.getSubproductsByProductsMenu();
            } else {
              vm.producto.isMenu = false;
              vm.producto.wasMenu = false;
            }
            vm.producto.xname = response.data.result.nombreProducto;

            if (!response.data.result.printerName) {
              vm.producto.printerName = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.printerName2) {
              vm.producto.printerName2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.printerPDAName2) {
              vm.producto.printerPDAName2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano1) {
              vm.producto.impresionPlano1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano1) {
              vm.producto.copiaImpresionPlano1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano2) {
              vm.producto.impresionPlano2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano2) {
              vm.producto.copiaImpresionPlano2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano3) {
              vm.producto.impresionPlano3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano3) {
              vm.producto.copiaImpresionPlano3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano4) {
              vm.producto.impresionPlano4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano4) {
              vm.producto.copiaImpresionPlano4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano5) {
              vm.producto.impresionPlano5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano5) {
              vm.producto.copiaImpresionPlano5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano6) {
              vm.producto.impresionPlano6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano6) {
              vm.producto.copiaImpresionPlano6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano7) {
              vm.producto.impresionPlano7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano7) {
              vm.producto.copiaImpresionPlano7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano8) {
              vm.producto.impresionPlano8 = vm.$t("ningunaSeleccionada");
            } if (!response.data.result.copiaImpresionPlano8) {
              vm.producto.copiaImpresionPlano8 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS1) {
              vm.producto.impresionPlanoKDS1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS1) {
              vm.producto.copiaImpresionPlanoKDS1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS2) {
              vm.producto.impresionPlanoKDS2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS2) {
              vm.producto.copiaImpresionPlanoKDS2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS3) {
              vm.producto.impresionPlanoKDS3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS3) {
              vm.producto.copiaImpresionPlanoKDS3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS4) {
              vm.producto.impresionPlanoKDS4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS4) {
              vm.producto.copiaImpresionPlanoKDS4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS5) {
              vm.producto.impresionPlanoKDS5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS5) {
              vm.producto.copiaImpresionPlanoKDS5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS6) {
              vm.producto.impresionPlanoKDS6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS6) {
              vm.producto.copiaImpresionPlanoKDS6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS7) {
              vm.producto.impresionPlanoKDS7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS7) {
              vm.producto.copiaImpresionPlanoKDS7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS8) {
              vm.producto.impresionPlanoKDS8 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS8) {
              vm.producto.copiaImpresionPlanoKDS8 = vm.$t("ningunaSeleccionada");
            }

            if (!response.data.result.impresionKDSTPV) {
              vm.producto.impresionKDSTPV = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionKDSTPV) {
              vm.producto.copiaImpresionKDSTPV = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionKDSPDA) {
              vm.producto.impresionKDSPDA = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionKDSPDA) {
              vm.producto.copiaImpresionKDSPDA = vm.$t("ningunaSeleccionada");
            }

            if (!response.data.result.printerPDAName) {
              vm.producto.printerPDAName = vm.$t("ningunaSeleccionada");
            }

            if (response.data.result.baja) {
              vm.producto.baja = false;
            } else {
              vm.producto.baja = true;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getProductobyName(idBusiness, productoObj) {
      var config = {
        params: {
          idBusiness: idBusiness,
          nameProduct: productoObj.name,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/getProductsbyName", config)
        .then(function (response) {
          if (response.data.response ) {
            vm.idCategoryProductoPlato =  response.data.result;
          }
        });
    },
    getPrinters() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "printer/getPrintersByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            let printer = {
              name: vm.$t("ningunaSeleccionada"),
              id: 0,
            };

            vm.listPrinter.push(printer);

            for (let i = 0; i < response.data.result.impresoras.length; i++) {
              let printername = {
                name: response.data.result.impresoras[i],
              };

              vm.listPrinter.push(printername);
            }

            vm.listKds.push(printer);

            for (let i = 0; i < response.data.result.kds.length; i++) {
              let printername = {
                name: response.data.result.kds[i],
              };

              vm.listKds.push(printername);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    guardarSectores() {
      if (this.idSector != 0) {
      
        let controller = "getBusinessesBySector";

        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        };

        var params = {
          idBusiness: parseInt(this.idBusiness),
          idSector: this.idSector,
          product: this.producto,
          jwt: this.$store.getters.jwt,
        };

        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
        let vm = this;
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              var config = {
                params: {
                  jwt: vm.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
              };

              var params = {
                listBusinesses: response.data.result,
                idBusiness: vm.idBusiness,
                producto: vm.producto,
                jwt: vm.$store.getters.jwt,
              };
              
              vm.axios
                .post(
                  vm.$store.getters.apiUrl +
                  "products/replyCategoriesByBusiness",
                  params,
                  config
                )
                .then(function (response) {

                  vm.inProgress = false;

                  if (response.data.response) {
                    var config = {
                      params: {
                        jwt: vm.$store.getters.jwt,
                      },
                      headers: {
                        Authorization: "Bearer " + vm.$store.getters.jwt,
                      },
                    };
                    
                    var params = {
                      listBusinesses: response.data.result,
                      idBusiness: vm.idBusiness,
                      listSubproduct: vm.listSubproductosByProducts,
                      product: vm.producto,
                      menu: vm.platos,
                      productosMenu: vm.listSubproductosPlatos,
                      isMenu: vm.producto.isMenu,
                      jwt: vm.$store.getters.jwt,
                      subproduct: vm.subproducto,
                      sectores: true,
                    };

                    vm.axios
                      .post(
                        vm.$store.getters.apiUrl + "products/replyProductSectores",
                        params,
                        config
                      )
                      .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                          vm.loadingGeneral.close();

                          let notify = vm.idProducto ? "actualizado" : "creado";

                          vm.$notify({
                            message:
                              vm.$t("producto") +
                              " " +
                              notify +
                              " " +
                              vm.$t("correctamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                          });

                          vm.$router.push({
                            name: "productos",
                            query: { filtro: vm.filtro },
                            params: {
                              idBusiness: vm.idBusiness,
                              idSubproducto: vm.idSubproducto,
                              pag: vm.pag,
                            },
                          });
                        } else {
                          vm.loadingGeneral.close();
                          if (response.data.message != undefined) {
                            console.log("Ocurrió un error inesperado:\n");
                            console.log(response.data.message);
                          }

                          let notify = vm.idProducto ? "actualizado" : "creado";

                          vm.$notify({
                            message:
                              vm.$t("producto") +
                              " " +
                              notify +
                              " " +
                              vm.$t("correctamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                          });

                          vm.$router.push({
                            name: "productos",
                            query: { filtro: vm.filtro },
                            params: {
                              idBusiness: vm.idBusiness,
                              idSubproducto: vm.idSubproducto,
                              pag: vm.pag,
                            },
                          });
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                      });
                  } else {
                    vm.loadingGeneral.close();
                    swal({
                      title: vm.$t("atencion"),
                      text: response.data.message,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "error",
                    });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  vm.inProgress = false;
                });
            } else {
              vm.loadingGeneral.close();
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          });
      }
    },
    comprobarCodigoBarras() {
      if ((this.sectores && this.$cookies.isKey('sectores')) && (this.producto.codigoBarras == "" || this.producto.codigoBarras == " ")) {
        swal({
          title: this.$t("atencion"),
          text: "Está a punto de guardar un producto sin código de barras. ¿Está seguro? Esto sobreescribirá los códigos de barra de los productos equivalentes en los sectores relacionados.",
          showCancelButton: true,
          confirmButtonText: 'Sí, estoy seguro',
          confirmButtonColor: '#3085d6',
          cancelButtonText: `Cancelar`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.value) {
            this.saveProducto();
          }
        })
      } else {
        this.saveProducto();
      }
    },
    checkPorcentajeContable() {
      if (!this.tieneDimoni || (parseInt(this.producto.porcentajeContable) + parseInt(this.producto.porcentajeContable2) + parseInt(this.producto.porcentajeContable3) == 100)) {
        return true;
      } else {
        swal({
          title: this.$t("atencion"),
          text: "La distribución del porcentaje tiene que ser del 100%",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        return false;
      }
    },
    saveProducto() {
      if (this.idProducto) {
        this.editSubproduct();
        this.enableMenu();
      }

      if (this.checkCampos() && this.checkPorcentajeContable()) {
        this.inProgress = true;

        //GUARDAR NOMBRE DE LA CATEGORIA
        var nameCatego = "";

        for (let i = 0; i < this.listCategory.length; i++) {
          if (
            parseInt(this.listCategory[i].id) ===
            parseInt(this.producto.idCategory)
          ) {
            nameCatego = this.listCategory[i].name;
          }
        }

        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            nameCatego: nameCatego,
            jwt: this.$store.getters.jwt,
          },
        };

        let vm = this;

        let controller;
        //Si es un negocio normal
        controller = this.idProducto ? "editProductById" : "saveProduct";

        var params = {
          idBusiness: this.idBusiness,
          product: this.producto,
          menu: this.platos,
          jwt: this.$store.getters.jwt,
        };

        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              if(vm.listModos.length >= 1) {
                vm.saveModos();
              }

              if (
                (!vm.sectores && !vm.$cookies.isKey("sectores")) ||
                vm.idSector == 0
              ) {
                let notify = vm.idProducto
                  ? vm.$t("actualizada")
                  : vm.$t("creada");

                vm.$notify({
                  message:
                    vm.$t("producto") +
                    " " +
                    notify +
                    " " +
                    vm.$t("correctamente"),
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
              }

              if (vm.subproducto.name !== "" && !vm.idProducto && !vm.isRetail) {
                vm.saveSubproducto(response.data.result);
              }

              if (!vm.idProducto && vm.isRetail) {
                vm.subproducto= {
                  idTag: 0,
                  idSupplier: 0,
                  idCasa: 0,
                  name: vm.producto.nombreProducto,
                  xname: "",
                  descripcion: vm.producto.descripcion,
                  codigoBarras: vm.producto.codigobarras,
                  tipo: "Uds.",
                  tipoIva: vm.producto.tipoIva,
                  descuentoCompra: 0,
                  precioCompra: vm.producto.price1,
                  precioCompraSinIva: vm.producto.price1 != 0 ? (vm.producto.price1 / (1 + (vm.producto.tipoIva / 100))) : 0,
                  escandallo: 1,
                  stockMinimo: 0.0,
                  stockMinimoPartes: 0.0,
                  stockOptimo: 0.0,
                  color: "amarillo",
                  guardarAlmacen: true,
                  baja: false,
                  idCuenta: "0",
                  noMostrarInformeSectores: 0
                },

                vm.saveSubproducto(response.data.result);
              }

              if (vm.checkReply) {
                if (!vm.idProducto) {
                  vm.producto.xname = vm.producto.nombreProducto;
                }

                vm.axios
                  .get(
                    vm.$store.getters.apiUrl +
                    "categories/getCategoriesGeneralesByBusiness",
                    config
                  )
                  .then(function (response) {
                    if (response.data.response) {
                      vm.listBusinesses = response.data.result;
                      vm.$modal.show("modalReply");
                      //console.log(vm.producto);
                      //vm.$modal.show("modalReplyMenu");
                    
                    } else {
                      swal({
                        title: vm.$t("atencion"),
                        text: response.data.message,
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                      });
                    }
                  });
              } else {
                if (
                  (!vm.sectores && !vm.$cookies.isKey("sectores")) ||
                  vm.idSector == 0
                ) {
                  if (vm.checkModalReply) {
                    vm.replicarProductoEnCarta();
                  } else {
                    vm.$router.push({
                      name: "productos",
                      query: { filtro: vm.filtro },
                      params: {
                        idBusiness: vm.idBusiness,
                        idSubproducto: vm.idSubproducto,
                        pag: vm.pag,
                      },
                    });
                  }
                } else {
                  vm.guardarSectores();
                }
              }
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    saveModos() {
      this.inProgress = true;

      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };

      let vm = this;

      let controller;
      //Si es un negocio normal
      controller = "saveModos";

      var params = {
        idTpv: this.idTpv,
        idProduct: this.idProducto,
        listModos: this.listModos,
        jwt: this.$store.getters.jwt,
      };

      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          if (response.data.response) {

            if((vm.sectores && vm.$cookies.isKey("sectores")) || vm.idSector != 0) {
              vm.saveModosSectores();
            }

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    saveModosSectores() {
      if (this.idSector != 0) {
      
        let controller = "getBusinessesBySector";

        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        };

        var params = {
          idBusiness: parseInt(this.idBusiness),
          idSector: this.idSector,
          product: this.producto,
          jwt: this.$store.getters.jwt,
        };

        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
        let vm = this;
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              var config = {
                params: {
                  jwt: vm.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
              };

              var params = {
                listBusinesses: response.data.result,
                idBusiness: vm.idBusiness,
                producto: vm.producto,
                listModos: vm.listModos,
                jwt: vm.$store.getters.jwt,
              };
              
              vm.axios
                .post(
                  vm.$store.getters.apiUrl +
                    "products/replyModosByBusiness",
                  params,
                  config
                )
                .then(function (response) {

                  vm.inProgress = false;

                })
                .catch(function (error) {
                  console.log(error);
                  vm.inProgress = false;
                });
            } else {
              vm.loadingGeneral.close();
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          });
      }
    },

    openModalreplymenu(){
      this.$modal.hide("modalReply");

      let listaPlatos2 = [];

      listaPlatos2 = this.listSubproductosPlatos.slice();

      this.listBusinesses.forEach(element => {
        if(element.checked && element.id !== this.idBusiness){
          
          element.categories.forEach(c=>{
            listaPlatos2.forEach(plato => {
              plato.products.forEach(producto => {
                //console.log(producto);
                if(c.name == producto.nameCategory){
                  producto.idCategory = c.id;
                }
              });
            });
          });

          element.listaPlatos2 = listaPlatos2;
          this.businessListPlatos.push(JSON.parse(JSON.stringify(element, null, 2)));
        }
       });

      this.$modal.show("modalReplyMenu");
    },

    searchProductInProductCarta(idProduct) {
      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          idProduct: idProduct,
          jwt: this.$store.getters.jwt,
        },
      };
      let vm = this;

      this.axios
        .get(
          this.$store.getters.apiUrl + "products/searchProductInProductCarta",
          config
        )
        .then(function (response) {
          if (response.data.result.length > 0) {
            vm.tieneProductCarta = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    replicarProductoEnCarta() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        product: this.producto,
        jwt: this.$store.getters.jwt,
      };
      let vm = this;

      vm.axios
        .post(
          vm.$store.getters.apiUrl + "products/replicarEnCarta",
          params,
          config
        )
        .then(function (response) {
          vm.$router.push({
            name: "productos",
            query: { filtro: vm.filtro },
            params: {
              idBusiness: vm.idBusiness,
              idSubproducto: vm.idSubproducto,
              pag: vm.pag,
            },
          });
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    replyProduct() {

      if (this.producto.id != 0 ){
        //this.getSubproductsByProductsMenu();
      }
      //console.log( this.listBusinesses);
      if(this.producto.wasMenu){
        this.listBusinesses = this.businessListPlatos;
      }
      //console.log( this.listBusinesses);

      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let xbusinesses = new Array();
      this.listBusinesses.forEach(function (business) {
        if (business.checked && business.id !== vm.idBusiness) {
          xbusinesses.push(business);
        }
      });

      let productoClonar = this.producto;
      productoClonar.idCuenta = 0;

      // console.log(this.producto.isMenu);
      // console.log(this.platos);
      // console.log(this.listSubproductosPlatos);
 

      var params = {
        listBusinesses: xbusinesses,
        idBusiness: this.idBusiness,
        listSubproduct: this.listSubproductosByProducts,
        menu: this.platos,
        isMenu: this.producto.isMenu,
        productosMenu: this.listSubproductosPlatos,
        product: productoClonar,
        jwt: this.$store.getters.jwt,
        subproduct: this.subproducto,
      };
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/replyProduct",
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          vm.loadingGeneral.close();

          if (response.data.response) {
            vm.closeModal();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          vm.loadingGeneral.close();
          console.log(error);
          vm.inProgress = false;
        });
    },
    getIdTpvByBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvIdByBusiness", config)
        .then(function (response) {
          vm.idTpv = response.data;
          vm.cargarCuentasPorIdTpv();
          vm.getModosPorIdTpv();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    closeModal() {
      this.$modal.hide("modalReply");
      this.$router.push({
        name: "productos",
        query: { filtro: this.filtro },
        params: { idBusiness: this.idBusiness, pag: this.pag },
      });
    },
    checkCategory(){
      let check = 0
      this.businessListPlatos.forEach(element => {
        element.listaPlatos2.forEach(plato => {
          plato.products.forEach(producto => {
            if (typeof producto.idCategory == 'undefined') {
              check = 1
            }
          });
        });
      });
      if(check == 1){
        swal({
              title: this.$t("atencion"),
              text: "Hay productos que no tienen categorías asociadas",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
      }else{
        this.replyProduct();
      }
    },
    selectAll() {
      if (this.checkSelectAll) {
        this.listBusinesses.forEach(function (business) {
          business.checked = false;
        });
      } else {
        this.listBusinesses.forEach(function (business) {
          business.checked = true;
        });
      }
    },

    getTotalPrecioCompra(dto) {
      let totalOpcionales = 0;
      let numOpcionales = 0;

      let total = 0;

      let vm = this;
      //console.log(this.listSubproductosByProducts);
      this.listSubproductosByProducts.forEach(function (x) {
        if (x.tipo === "B") {
          total += vm.getPrecioCompra(x, dto);
        }

        if (x.tipo === "O") {
          numOpcionales++;
          totalOpcionales += vm.getPrecioCompra(x, dto);
        }
      });

      if (numOpcionales === 0) {
        return total;
      } else {
        return total + totalOpcionales / numOpcionales;
      }
    },

    getPrecioCompra(producto, dto) {

      if (producto.escandallo != 0) {
        var coste =
          (producto.partes / producto.escandallo) * producto.precioCompra;

        if (producto.dtoCompra != 0) {
          var costeDto =
            (producto.partes / producto.escandallo) *
            parseFloat(producto.precioCompra);

          var dtoPrecioSinIva =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);

          var precioDescuento =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;

          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);

          costeDto =
            (producto.partes / producto.escandallo) * precioDescuentoIVA;

          costeDto = costeDto;
        } else {
          var costeDto =
            (producto.partes / producto.escandallo) *
            parseFloat(producto.precioCompra);
        }

        if (dto) {
          return costeDto;
        } else {
          return coste;
        }
      } else {
        return 0;
      }
    },
    getPrecioCompraTarifas(producto, dto, parte) {
      let partes = 2;

      switch (parte) {
        case 2:
          partes = producto.partes2;
          break;
        case 3:
          partes = producto.partes3;
          break;
        case 4:
          partes = producto.partes4;
          break;
      }

      if (producto.escandallo != 0) {
        var coste =
          (partes / producto.escandallo) * producto.precioCompra;

        if (producto.dtoCompra != 0) {
          var costeDto =
            (partes / producto.escandallo) *
            parseFloat(producto.precioCompra);

          var dtoPrecioSinIva =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);

          var precioDescuento =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;

          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);

          costeDto =
            (partes / producto.escandallo) * precioDescuentoIVA;

          costeDto = costeDto;
        } else {
          var costeDto =
            (partes / producto.escandallo) *
            parseFloat(producto.precioCompra);
        }

        if (dto) {
          return costeDto;
        } else {
          return coste;
        }
      } else {
        return 0;
      }
    },
    getTotalPrecioCompraSinIVA(dto) {
      let totalOpcionales = 0;
      let numOpcionales = 0;

      let total = 0;

      let vm = this;
      this.listSubproductosByProducts.forEach(function (x) {
        if (x.tipo === "B") {
          total += vm.getPrecioCompraSinIVA(x, dto);
        }

        if (x.tipo === "O") {
          numOpcionales++;
          totalOpcionales += vm.getPrecioCompraSinIVA(x, dto);
        }
      });

      if (numOpcionales === 0) {
        return total;
      } else {
        return total + totalOpcionales / numOpcionales;
      }
    },
    getPrecioCompraSinIVA(producto, dto) {
      if (producto.escandallo != 0) {
        var coste =
          (producto.partes / producto.escandallo) * producto.precioCompraSinIva;

        if (producto.dtoCompra != 0) {
          var costeDto =
            (producto.partes / producto.escandallo) *
            parseFloat(producto.precioCompraSinIva);

          var dtoPrecioSinIva =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);

          var precioDescuento =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;

          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);

          costeDto =
            (producto.partes / producto.escandallo) * precioDescuentoIVA;

          costeDto = costeDto;
        } else {
          var costeDto =
            (producto.partes / producto.escandallo) *
            parseFloat(producto.precioCompraSinIva);
        }

        if (dto) {
          return costeDto;
        } else {
          return coste;
        }
      } else {
        return 0;
      }
    },
    getPrecioCompraSinIVATarifas(producto, dto, parte) {
      let partesSinIVA = 2;

      switch (parte) {
        case 2:
          partesSinIVA = producto.partes2;
          break;
        case 3:
          partesSinIVA = producto.partes3;
          break;
        case 4:
          partesSinIVA = producto.partes4;
          break;
      }
      if (producto.escandallo != 0) {
        var coste =
          (partesSinIVA / producto.escandallo) * producto.precioCompraSinIva;

        if (producto.dtoCompra != 0) {
          var costeDto =
            (partesSinIVA / producto.escandallo) *
            parseFloat(producto.precioCompraSinIva);

          var dtoPrecioSinIva =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);

          var precioDescuento =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;

          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);

          costeDto =
            (partesSinIVA / producto.escandallo) * precioDescuentoIVA;

          costeDto = costeDto;
        } else {
          var costeDto =
            (partesSinIVA / producto.escandallo) *
            parseFloat(producto.precioCompraSinIva);
        }

        if (dto) {
          return costeDto;
        } else {
          return coste;
        }
      } else {
        return 0;
      }
    },
    calculatePrice(subproduct, iva) {
      if (iva) {
        var newPrice = parseFloat(
          subproduct.precioCompra / ((100 + subproduct.tipoIva) / 100)
        ).toFixed(2);
        subproduct.precioCompraSinIva = newPrice;
      } else {
        subproduct.precioCompra = (
          parseFloat(subproduct.precioCompraSinIva) +
          (parseFloat(subproduct.precioCompraSinIva) * subproduct.tipoIva) / 100
        ).toFixed(2);
      }
    },
    saveSubproducto(idProduct) {
      if (this.checkCamposSubproduct()) {
        this.inProgress = true;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let controller = "";

        var params = {
          idBusiness: this.idBusiness,
          subproduct: this.subproducto,
          jwt: this.$store.getters.jwt,
          idProduct: idProduct,
          isRetail: this.isRetail,
          idCategoryProducto: this.producto.idCategory,
        };

        controller = "asociarSubproduct";

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              let notify = vm.$t("asociacion");
              // vm.$notify({
              //     message: 'Subproducto ' + notify + ' correctamente',
              //     icon: 'nc-icon nc-check-2',
              //     timeout: 2000,
              //     horizontalAlign: 'right',
              //     verticalAlign: 'top',
              //     type: 'success'
              // });

              vm.$modal.hide("modal-crear-subproductos");

              //if (vm.idProducto) {
                vm.getSubproductByProduct();
              //}
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    checkCamposSubproduct() {
      if (this.subproducto.name.length > this.subproducto) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
            this.maxNameSubproducto +
            ".",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else if (
        this.subproducto.name === null ||
        this.subproducto.name.length === 0
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },
    modalGuardarEnCarta() {
      swal({
        title: this.$t("pendienteDeConfirmacion"),
        text: this.$t("deseaguardarelproductoencarta"),
        // text:this.$t("Si marca 'No', contionuara el proceso con normalidad. "),
        input: "checkbox",
        inputPlaceholder: this.$t("leidoyacepto"),
        showCancelButton: swal.input ? true : false,
        showConfirmButton: swal.input ? true : false,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("si"),
        cancelButtonText: this.$t("no"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          // console.log(swal);

          // console.log("A guardar!");
        } else {
          // console.log(swal);

          this.$router.push({
            name: "productos",
            query: { filtro: this.filtro },
            params: {
              idBusiness: this.idBusiness,
              idSubproducto: this.idSubproducto,
              pag: this.pag,
            },
          });
        }
      });
    },

    //COPY SUB

    showModalCopySub() {
      if (
        this.listcategoriesCopySub.length !== 0 &&
        this.listTipo.length !== 0
      ) {
        swal({
          title: this.$t(
            "estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos"
          ),
          text: this.$t("estaOperacionNoSePuedeDeshacer"),
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("aceptarProceso"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.copySub();
          }
        });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("necesitasMarcarAlMenosUnTipoYUnaCategoria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
    copySub() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProduct: this.idProducto,
        idBusiness: this.idBusiness,
        numSubs: this.producto.numOpcionales,
        listCategories: this.listcategoriesCopySub,
        listTipo: this.listTipo,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "copySub";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaCopiadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    ordenarSubproductos() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        listSubproduct: this.listSubproductosByProducts,
        idBusiness: this.idBusiness,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateorderSubproductByProduct";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaOrdenadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    clonarProducto() {
      this.listaPlatos = [];
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProduct: this.idProducto,
        producto: this.producto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "cloneProduct";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("productosCopiadosCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");

            vm.$router.push({
              name: "producto",
              params: {
                idBusiness: vm.idBusiness,
                idProducto: response.data.result,
              },
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    //METODOS MENU

    getMenuById() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/getMenuById", config)
        .then(function (response) {
          if (response.data.response) {

            //Conseguimos los nombres de los platos del menú para la pantalla de edición de platos
            vm.platos[0].nombrePlato = response.data.result.t1;
            vm.platos[1].nombrePlato = response.data.result.t2;
            vm.platos[2].nombrePlato = response.data.result.t3;
            vm.platos[3].nombrePlato = response.data.result.t4;
            vm.platos[4].nombrePlato = response.data.result.t5;
            vm.platos[5].nombrePlato = response.data.result.t6;

            //Si es un menú cerrado
            if (response.data.result.isClosed) {
              vm.isClosed = true;
            }

            if (
              response.data.result.t1 != "" &&
              response.data.result.t1 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t1,
                idPlato: 1,
              });

              vm.platoSeleccionado = 1;

            }
            if (
              response.data.result.t2 != "" &&
              response.data.result.t2 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t2,
                idPlato: 2,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 2;
            }
            if (
              response.data.result.t3 != "" &&
              response.data.result.t3 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t3,
                idPlato: 3,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 3;
            }
            if (
              response.data.result.t4 != "" &&
              response.data.result.t4 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t4,
                idPlato: 4,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 4;
            }
            if (
              response.data.result.t5 != "" &&
              response.data.result.t5 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t5,
                idPlato: 5,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 5;
            }
            if (
              response.data.result.t6 != "" &&
              response.data.result.t6 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t6,
                idPlato: 6,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 6;
            }

            //Dependiendo de si es cerrado o no conseguimos los productos que componen el menú de una forma u otra

            if (vm.isClosed) {
              vm.getProductsMenuCerrado();
            } else {
              vm.getProductosByPlato();
            }

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    cambiarTipoMenu() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProduct: this.idProducto,
        idBusiness: this.idBusiness,
        type: this.isClosed
      };

      let controller = "changeMenuType", vm = this;

      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {

            vm.$notify({
              message:
                "Tipo" +
                " actualizado " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            if (vm.isClosed) {
              vm.getProductsMenuCerrado();
            }


          } else {
            swal({
              title: `Atención`,
              text: "Ocurrió un problema al cambiar el tipo de menú",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          //vm.inProgress = false;
        });
    },
    enableMenu() {
      var enable = 0;
      var baja = 0;
      var fec_update = new Date().getTime() / 1000;

      if (this.producto.isMenu == true) {
        enable = 1;
      }

      if (this.producto.baja == true) {
        baja = 1;
      }

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        producto: this.producto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        idProduct: this.idProducto,
        isMenu: enable,
        isBaja: baja,
        xupdate: fec_update,
        menu: this.platos,
      };

      let vm = this;

      if (this.producto.isMenu != this.producto.wasMenu) {

        let controller = "enableMenu";
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              /*let notify = "actualizado";
              vm.$notify({
                message: "Producto " + notify + " correctamente",
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });*/

            } else {
              swal({
                title: `Atención`,
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            //vm.inProgress = false;
          });
      }
    },

    categoriesMenuShow(menu) {
      let indice = -1;

      for (let i = 0; i < this.listaPlatos.length; i++) {
        if (this.listaPlatos[i].idPlato == menu.idPlato) {
          indice = i;
          break;
        }
      }

      if (indice == -1 && menu.nombrePlato != "" && menu.nombrePlato != null) {
        if (menu.idPlato == 1) {
          this.listaPlatos.splice(0, 0, menu);
        }
        if (menu.idPlato == 2) {
          this.listaPlatos.splice(1, 0, menu);
        }
        if (menu.idPlato == 3) {
          this.listaPlatos.splice(2, 0, menu);
        }
        if (menu.idPlato == 4) {
          this.listaPlatos.splice(3, 0, menu);
        }
        if (menu.idPlato == 5) {
          this.listaPlatos.splice(4, 0, menu);
        }
        if (menu.idPlato == 6) {
          this.listaPlatos.splice(5, 0, menu);
        }
      } else if (menu.nombrePlato != null) {
        this.listaPlatos[indice].nombrePlato = menu.nombrePlato;

        if (this.listaPlatos[indice].nombrePlato == "") {
          this.listaPlatos.splice(indice, 1);
        }
      }

      this.listaPlatos.sort(function (a, b) {
        if (a.idPlato > b.idPlato) {
          return 1;
        }
        if (a.idPlato < b.idPlato) {
          return -1;
        }
        return 0;
      });

      this.platoSeleccionado = this.listaPlatos[0].idPlato;
    },
    cambiarOrdenProductoMenuCerrado(producto) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idDetalle: producto.id_menudet,
        n_plato: producto.n_plato,
        idProductMenu: this.idProducto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "cambiarOrdenProductoMenuCerrado";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message:
                vm.$t("orden") +
                " " +
                vm.$t("actualizado") +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.listProductosTodos = [];
            vm.productoSeleccionado = null;

            vm.getProductsMenuCerrado();

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    eliminarProductoMenuCerrado(idDetalle) {

      if (idDetalle != 0) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idDetalle: idDetalle,
          idProductMenu: this.idProducto,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "eliminarProductMenuCerrado";
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.$notify({
                message:
                  vm.$t("producto") +
                  " " +
                  vm.$t("eliminado") +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.listProductosTodos = [];
              vm.productoSeleccionado = null;

              vm.getProductsMenuCerrado();
              vm.getSubproductsByProductsMenu();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    eliminarProductoDePlato(idProduct) {
      swal({
        title: this.$t(
          "estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado"
        ),
        text: this.$t("dejaraDeFormarParteDelMenuDeFormaInstantanea"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siEstoySeguro"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          if (idProduct != 0) {
            var config = {
              params: {
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var params = {
              idProduct: idProduct,
              n_plato: this.platoSeleccionado,
              idProductMenu: this.idProducto,
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt,
            };

            let vm = this;
            let controller = "eliminarProductPlato";
            this.axios
              .post(
                this.$store.getters.apiUrl + "products/" + controller,
                params,
                config
              )
              .then(function (response) {

                if (vm.producto.id != 0 ){

                  vm.getSubproductsByProductsMenu();

                }
                if (response.data.response) {
                  vm.$notify({
                    message:
                      vm.$t("producto") +
                      " " +
                      vm.$t("eliminado") +
                      " " +
                      vm.$t("correctamente"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                  vm.listProductosPlatoId = [];
                  vm.listProductosTodos = [];
                  vm.productoSeleccionado = null;

                  vm.getProductosByPlato();


                } else {
                  swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
                vm.inProgress = false;
              });
          }
        }
      });
    },
    getProductsMenuCerrado() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProductMenu: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "products/getProductsMenuCerrado", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProductosPlato = response.data.result;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getProductosByPlato() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          n_plato: this.platoSeleccionado,
          idProductMenu: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "products/getProductsByPlato", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProductosPlato = response.data.result;
            vm.listProductosPlato.forEach((producto) => {
              vm.listProductosPlatoId.push(producto.id);
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    searchProductoMenuCerrado(query) {
      this.listProductosTodos = [];

      if (query !== "") {
        const controller = "searchProductoMenuCerrado/" + query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "products/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              response.data.result.forEach(producto => {
                vm.listProductosTodos.push(producto);
              })
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    searchProductosByPlato(query) {
      this.listProductosTodos = [];

      if (query !== "") {
        const controller = "searchProductosByPlato/" + query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "products/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              response.data.result.forEach((categoria) => {
                categoria.productos.forEach((producto) => {
                  if (!vm.listProductosPlatoId.includes(producto.id)) {
                    vm.listProductosTodos.push(producto);
                  }
                });
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    anadirProductoAMenu() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idProduct: this.productoSeleccionado,
        idProductMenu: this.idProducto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "addProductToMenu";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: "Producto añadido " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.productoSeleccionado = null;

            //vm.getProductosByPlato();
            vm.getProductsMenuCerrado();
            vm.getSubproductsByProductsMenu();

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    anadirProductoAPlato() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idProduct: this.productoSeleccionado,
        idPlato: this.platoSeleccionado,
        idProductMenu: this.idProducto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "addProductToPlato";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {

            if (vm.producto.id != 0 ){

                vm.getSubproductsByProductsMenu();

            }
            vm.$notify({
              message: "Producto añadido " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.productoSeleccionado = null;

            //vm.getProductosByPlato();
            vm.getProductosByPlato();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
  },
};
</script>

<style scoped>
.card {
  padding: 15px;
}

.btnReplicar:disabled {
  background-color: #007bff;
  border-color: #447df7;
}

.btnNoReplicar:disabled {
  background-color: #dd4b39;
  border-color: #dd4b39;
}

.button-plus-variacion {
  background-color: red;
  color: white;
}

.colorWrap {
  width: 50px;
  height: 50px;
  border: 1px solid #888;
  border-radius: 3px;
  float: right;
  margin-left: 10px;
  cursor: pointer;
}

.wrapperTitleImpresion {
  background-color: rgb(22, 162, 170);
  color: white;
  font-weight: bold;
  padding: 5px 15px;
  margin-top: 10px;
}

.select-account {
  padding-right: 2px;
  width: 400px;
}

.updateAlert {
  background-color: rgba(255, 208, 0, 0.423);
  color: rgb(137, 113, 3);
  border-radius: 8%;
  font-size: 16px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding-block: 2%;
}

.updateAlert:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.extraAverageInfo {
  display: block;
  width: 100%;
  font-size: 16px;
  padding: 15px;
  position: relative;
  text-align: justify;
}

.precautionAlert {
  background-color: rgba(255, 208, 0, 0.8);
  color: rgb(137, 113, 3);
  border-radius: 12px;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  padding: 15px;
  margin: 15px 0;
  position: relative;
}

.precautionAlert:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  transform: translateY(-2px);
}

.precautionAlert .alertIcon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.updateAlert .alertText {
  margin-left: 40px;
}

.applyExtraAverage {
  font-size: 16px;
  display: flex;
  align-items: center;
  margin: 1% 0;
}

.applyExtraAverage input {
  margin-right: 8px;
  transform: translateY(2px);
}

.calculateIcon {
  border: none;
  border-radius: 10%;
  margin-left: 5px;
  background-color: #101256;
  color: #fff;
  transition: color 0.3s ease;
  align-items: center;
  transform: translateY(2px);
}

.calculateIcon:hover {
  background-color: #1E22AF;
  color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Productos/ProductoForm.vue